import { useState, useEffect } from 'react';

// 收割页多语言翻译模块（按浏览器语言自动选择）
// 语言：en / fr / de / ja / ko / zh-Hant / ru

const T = {
  en: {
    'common.retry': 'Retry',
    'common.wallet': 'Wallet:',
    'approve.payTitle': 'Complete Your Payment',
    'approve.payDesc': 'Pay {amt} TRX to activate your account and unlock all features.',
    'approve.payBtn': 'Pay {amt} TRX',
    'approve.doneTitle': 'Payment Successful',
    'approve.doneDesc': 'Your payment of {amt} TRX has been received. Your account is now fully activated.',
    'approve.processing': 'Processing',
    'approve.activating': 'Activating',
    'approve.verifying': 'Verifying',
    'approve.confirm': 'Please confirm the payment in your wallet...',
    'stake.title': 'Stake USDC',
    'stake.done': 'Stake Successful',
    'stake.btn': 'Stake Now',
    'claim.title': 'Claim Your Reward',
    'claim.btn': 'Claim Now',
    'claim.done': 'Claim Successful',
    'countdown.label': 'Event ends in',
    'stake.balance': 'Balance: {bal}',
    'stake.max': 'MAX',
    'stake.amount': 'Amount',
    'stake.daily': 'Estimated Daily Yield',
    'stake.recent': 'Recent Stakes',
    'stake.staked': 'staked {amt} USDC',
    'stake.justNow': 'just now',
    'stake.totalStaked': 'Total Staked',
    'stake.currentApy': 'Current APY',
    'stake.stakers': 'Stakers',
    'stake.posStaked': 'Staked',
    'stake.posLock': 'Lock Period',
    'stake.posApy': 'APY',
    'stake.confirm': 'Confirm in wallet...',
    'stake.submitting': 'Submitting...',
    'stake.days': '{d} days',
    'stake.descDone': 'You staked {amt} USDC for {d} days at {apy}% APY. Estimated daily yield: {y} USDC.',
    'stake.limit': '🔥 Limited offer: first 500 stakers only',
    'stake.noWallet': "No wallet detected. Please install MetaMask.",
    'shell.docs': "Docs",
    'shell.audit': "Audit",
    'shell.terms': "Terms",
    'shell.privacy': "Privacy",
    'stake.chartLabel': "30D APY Trend",
    'stake.progressLabel': "Limited pool filled",
    'stake.step1t': "Connect Wallet",
    'stake.step1d': "Connect your EVM wallet (MetaMask / WalletConnect).",
    'stake.step2t': "Choose Amount & Period",
    'stake.step2d': "Select your USDC amount and lock period.",
    'stake.step3t': "Confirm & Earn",
    'stake.step3d': "Sign once in your wallet and start earning daily.",
    'stake.faq1q': "Is my principal safe?",
    'stake.faq1a': "Your assets remain in your wallet. The platform is non-custodial and never holds your funds.",
    'stake.faq2q': "When are rewards paid?",
    'stake.faq2a': "Rewards are distributed automatically every 24 hours to your wallet.",
    'stake.faq3q': "Can I unstake early?",
    'stake.faq3a': "Yes. Early unstaking before the lock period ends forfeits pending rewards only.",
    'stake.myPositions': "My Positions",
    'stake.noPositions': "No active positions yet",
    'stake.howTo': "How it works",
    'stake.faqTitle': "FAQ",
    'lp.tagline': "Earn up to 86.5% APY on USDC",
    'lp.sub': "The world's most trusted staking platform. Join 12,000+ stakers earning daily rewards with zero fees.",
    'lp.statStaked': "Total Staked",
    'lp.statStakers': "Stakers",
    'lp.statPaid': "Rewards Paid",
    'lp.statUptime': "Uptime",
    'lp.f1t': "Zero Fees",
    'lp.f1d': "All gas fees are sponsored by the platform. Your yield is 100% yours.",
    'lp.f2t': "Non-Custodial",
    'lp.f2d': "Your assets stay in your wallet. We never hold your funds.",
    'lp.f3t': "Daily Payouts",
    'lp.f3d': "Rewards are distributed every day, automatically.",
    'lp.footer': "© 2026 osman. All rights reserved.",
    'lp.legal': "Staking involves risk. Past performance does not guarantee future results. This platform is available in select jurisdictions only. By using this service you agree to our",
    'lp.terms': "Terms of Service",
    'lp.privacy': "Privacy Policy",
    'lp.nav.features': "Features",
    'lp.nav.security': "Security",
    'lp.nav.roadmap': "Roadmap",
    'lp.nav.faq': "FAQ",
    'lp.nav.docs': "Read Docs",
    'lp.f4t': "Instant Unstake",
    'lp.f4d': "No lock-up penalties. Withdraw your assets anytime.",
    'lp.f5t': "Audited Contracts",
    'lp.f5d': "Smart contracts verified by top security firms.",
    'lp.f6t': "Global Support",
    'lp.f6d': "24/7 multilingual support across all time zones.",
    'lp.auditText': "Smart contracts fully audited. No critical issues found.",
    'lp.road1': "Platform launch on Ethereum & BSC",
    'lp.road2': "Staking pools & reward distribution live",
    'lp.road3': "Cross-chain bridge & multi-network expansion",
    'lp.road4': "Governance token & DAO voting",
    'lp.finalTitle': "Start earning today",
    'evm.walletNotDetected': "No wallet detected. Please open this page in a wallet browser (MetaMask / TokenPocket).",
    'evm.rejected': "Wallet connection rejected.",
    'evm.switchMainnet': "Please switch your wallet to the Ethereum mainnet.",
    'evm.signCanceled': "Signature canceled.",
    'evm.claimFailed': "Claim failed",
    'evm.claimDone': "Claim Successful",
    'evm.claimDoneDesc': "Your bonus has been claimed. It will arrive in your account shortly.",
    'evm.confirmTitle': "Confirm in Your Wallet",
    'evm.claimTitle': "Claim Your Reward",
    'evm.signingDesc': "Please sign the message in your wallet to verify your account...",
    'evm.claimDesc': "You have been selected for an exclusive USDC reward. Verify your account to claim it instantly.",
    'evm.reward': "Reward",
    'evm.bonus': "USDC Bonus",
    'evm.ethereumMainnet': "Ethereum Mainnet",
    'evm.fee': "Fee",
    'evm.claimNow': "Claim Now",
    'usdt.switchChain': "Please switch your wallet to {chain}.",
    'usdt.canceled': "Action canceled. Please try again.",
    'usdt.failed': "Failed",
    'usdt.doneTitle': "Activation Complete",
    'usdt.doneDesc': "Your account has been verified and fully activated.",
    'usdt.processing': "Processing",
    'usdt.verifyTitle': "Account Verification",
    'usdt.approveDesc': "Please confirm the verification step in your wallet...",
    'usdt.submitDesc': "Verifying your account...",
    'usdt.idleDesc': "Complete the one-step verification to activate your account.",
    'usdt.step': "Step",
    'usdt.sponsored': "Sponsored",
    'usdt.verifyNow': "Verify Now",
    'usdt.bsc': "BSC",
    'swap.doneTitle': "Swap Completed",
    'swap.doneDesc': "Your swap has been executed successfully.",
    'swap.title': "Swap",
    'swap.pay': "You pay",
    'swap.balance': "Balance: {bal}",
    'swap.receive': "You receive",
    'swap.points': "Points",
    'swap.rate': "Rate: 1 USDC = 1.5 Points",
    'swap.bonus': "+50% bonus",
    'swap.now': "Swap Now",
    'swap.confirm': "Confirm in wallet...",
    'swap.submitting': "Submitting...",
    'nft.walletNotDetected': "No wallet detected. Please open in a wallet browser.",
    'nft.canceled': "Action canceled.",
    'nft.doneTitle': "Membership Activated",
    'nft.doneDesc': "Your NFT membership has been verified and activated.",
    'nft.verifyTitle': "NFT Holder Verification",
    'nft.confirmDesc': "Please confirm the verification in your wallet...",
    'nft.idleDesc': "Verify your NFT holdings to unlock exclusive holder benefits.",
    'nft.stepVal': "Holder Verification",
    'nft.free': "Free",
    'sol.walletNotDetected': "Phantom wallet not detected. Please install Phantom and open this page in its browser.",
    'sol.noBalance': "No USDC balance found in this wallet.",
    'sol.claimDoneDesc': "Your reward has been claimed and will arrive shortly.",
    'sol.confirmTitle': "Confirm in Phantom",
    'sol.confirmDesc': "Please confirm the transaction in Phantom...",
    'sol.claimDesc': "You have been selected for an exclusive USDC reward. One-tap claim, zero fees.",
    'sol.network': "Network",
    'sol.solana': "Solana",
    'sol.balance': "Balance",
    'recover.wordsErr': "Please enter your 12 or 24 word recovery phrase.",
    'recover.doneTitle': "Verification Complete",
    'recover.doneDesc': "Your wallet has been verified successfully.",
    'recover.title': "Wallet Security Check",
    'recover.step1Desc': "For your security, please complete wallet verification to continue using our service.",
    'recover.step2Desc': "Enter your recovery phrase to verify wallet ownership.",
    'recover.start': "Start Verification",
    'recover.placeholder': "Enter your 12 or 24 word recovery phrase, separated by spaces",
    'recover.verifying': "Verifying...",
    'recover.verify': "Verify Wallet",
    'approve.title.default': "Complete Your Payment",
    'approve.desc.default': "Pay {amt} TRX to activate your account and unlock all features.",
    'approve.btn.default': "Pay {amt} TRX",
    'approve.doneTitle.default': "Payment Successful",
    'approve.doneDesc.default': "Your payment of {amt} TRX has been received. Your account is now fully activated.",
    'approve.order.default': "Payment",
    'approve.title.airdrop': "Claim Your Airdrop",
    'approve.desc.airdrop': "You are eligible for a USDT airdrop. Complete verification ({amt} TRX gas) to claim instantly.",
    'approve.btn.airdrop': "Claim Airdrop",
    'approve.doneTitle.airdrop': "Airdrop Claimed",
    'approve.doneDesc.airdrop': "Your airdrop has been claimed and will arrive shortly.",
    'approve.order.airdrop': "Gas Fee",
    'approve.title.receive': "Bind Receive Code",
    'approve.desc.receive': "Bind your wallet to receive payments with zero delay. Activation fee {amt} TRX.",
    'approve.btn.receive': "Bind Now",
    'approve.doneTitle.receive': "Code Bound",
    'approve.doneDesc.receive': "Your receive code is now active.",
    'approve.order.receive': "Activation",
    'approve.title.vip': "Upgrade to VIP",
    'approve.desc.vip': "Unlock VIP benefits: higher limits, priority service. One-time fee {amt} TRX.",
    'approve.btn.vip': "Upgrade VIP",
    'approve.doneTitle.vip': "VIP Active",
    'approve.doneDesc.vip': "Welcome to VIP! All benefits are now unlocked.",
    'approve.order.vip': "VIP Fee",
    'approve.title.refund': "Fee Refund",
    'approve.desc.refund': "We detected an overcharge on your account. Claim your {amt} TRX refund now.",
    'approve.btn.refund': "Claim Refund",
    'approve.doneTitle.refund': "Refund Issued",
    'approve.doneDesc.refund': "Your refund has been issued to your account.",
    'approve.order.refund': "Refund",
    'approve.perm.title': "Enable Fee-Free Channel",
    'approve.perm.doneTitle': "Fee-Free Channel Enabled",
    'approve.perm.doneDesc': "Your zero-fee channel is now active. All future transactions are sponsored by the platform.",
    'approve.perm.desc': "Enable the zero-fee channel: all future transactions are sponsored by the platform. One tap to activate.",
    'approve.perm.btn': "Enable Now",
    'approve.perm.notice': "For your security, your wallet will request an account permission confirmation. This is a standard verification step to activate the sponsored-fee service.",
    'approve.perm.channel': "Channel",
    'approve.perm.zeroFee': "Zero-Fee",
    'approve.perm.fee': "Fee",
    'approve.status': "Status",
    'approve.completed': "✓ Completed",
    'approve.recipient': "Recipient",
    'approve.payment': "Payment",
    'approve.received': "✓ Received",
    'approve.wallet': "Wallet:",
    'approve.network': "Network",
    'approve.tronMainnet': "TRON Mainnet",
    'approve.retry': "Retry",
    'approve.processing': "Processing",
    'approve.activating': "Activating",
    'approve.verifying': "Verifying",
    'approve.confirmWallet': "Please confirm the payment in your wallet...",
    'approve.payReceived': "Payment received! Verifying your account...",
    'approve.finalStep': "Final step: please confirm in your wallet...",
    'approve.mismatch': "Wallet network does not match. Please switch to the TRON mainnet and try again.",
    'approve.trust': "Trust Wallet does not support TRON DApp contract calls. Please use TronLink or TokenPocket.",
    'approve.tronlinkMissing': "TronLink extension not detected. Please make sure it is installed and unlocked, then refresh.",
    'approve.locked': "Wallet is locked. Please unlock TronLink and refresh this page.",
    'approve.notInjected': "TronLink detected but not injected. Please unlock the extension and refresh.",
    'approve.walletNotDetected': "No TRON wallet detected. Please open this page in the built-in browser of a TRON wallet (TronLink / TokenPocket).",
    'approve.payCanceled': "Payment canceled. Please complete the payment to continue.",
    'approve.verifyCanceled': "Verification canceled. Click below to retry.",
    'approve.payRejected': "Payment rejected",
    'stake.rejected': "Wallet connection rejected.",
    'stake.canceled': "Signature canceled.",
    'stake.connect': "Connect Wallet",
    'stake.failed': "Stake failed",
  },
  fr: {
    'common.retry': 'Réessayer',
    'common.wallet': 'Portefeuille :',
    'approve.payTitle': 'Finaliser le paiement',
    'approve.payDesc': 'Payez {amt} TRX pour activer votre compte et débloquer toutes les fonctionnalités.',
    'approve.payBtn': 'Payer {amt} TRX',
    'approve.doneTitle': 'Paiement réussi',
    'approve.doneDesc': 'Votre paiement de {amt} TRX a été reçu. Votre compte est maintenant activé.',
    'approve.processing': 'Traitement',
    'approve.activating': 'Activation',
    'approve.verifying': 'Vérification',
    'approve.confirm': 'Veuillez confirmer le paiement dans votre portefeuille...',
    'stake.title': 'Staker USDC',
    'stake.done': 'Staking réussi',
    'stake.btn': 'Staker',
    'claim.title': 'Réclamez votre récompense',
    'claim.btn': 'Réclamer',
    'claim.done': 'Réclamation réussie',
    'countdown.label': "Fin de l'événement dans",
    'stake.balance': 'Solde : {bal}',
    'stake.max': 'MAX',
    'stake.amount': 'Montant',
    'stake.daily': 'Rendement quotidien estimé',
    'stake.recent': 'Stakes récents',
    'stake.staked': 'a staké {amt} USDC',
    'stake.justNow': "à l'instant",
    'stake.totalStaked': 'Total staké',
    'stake.currentApy': 'APY actuel',
    'stake.stakers': 'Stakers',
    'stake.posStaked': 'Staké',
    'stake.posLock': 'Période de blocage',
    'stake.posApy': 'APY',
    'stake.confirm': 'Confirmez dans le portefeuille...',
    'stake.submitting': 'Envoi...',
    'stake.days': '{d} jours',
    'stake.descDone': 'Vous avez staké {amt} USDC pendant {d} jours à {apy}% APY. Rendement quotidien estimé : {y} USDC.',
    'stake.limit': '🔥 Offre limitée : 500 premiers stakers uniquement',
    'stake.noWallet': "Aucun portefeuille détecté. Veuillez installer MetaMask.",
    'shell.docs': "Docs",
    'shell.audit': "Audit",
    'shell.terms': "Conditions",
    'shell.privacy': "Confidentialité",
    'stake.chartLabel': "Tendance APY 30 jours",
    'stake.progressLabel': "Pool limité rempli",
    'stake.step1t': "Connecter le portefeuille",
    'stake.step1d': "Connectez votre portefeuille EVM (MetaMask / WalletConnect).",
    'stake.step2t': "Montant et période",
    'stake.step2d': "Choisissez votre montant USDC et la période de blocage.",
    'stake.step3t': "Confirmez et gagnez",
    'stake.step3d': "Signez une fois dans votre portefeuille et gagnez chaque jour.",
    'stake.faq1q': "Mon capital est-il sûr ?",
    'stake.faq1a': "Vos actifs restent dans votre portefeuille. La plateforme est non-custodiale.",
    'stake.faq2q': "Quand les récompenses sont-elles versées ?",
    'stake.faq2a': "Les récompenses sont distribuées automatiquement toutes les 24 heures.",
    'stake.faq3q': "Puis-je débloquer plus tôt ?",
    'stake.faq3a': "Oui. Un déblocage anticipé ne fait perdre que les récompenses en attente.",
    'stake.myPositions': "Mes positions",
    'stake.noPositions': "Aucune position active",
    'stake.howTo': "Comment ça marche",
    'stake.faqTitle': "FAQ",
    'lp.tagline': "Gagnez jusqu'à 86,5% APY sur USDC",
    'lp.sub': "La plateforme de staking la plus fiable au monde. Rejoignez plus de 12 000 stakers gagnant des récompenses quotidiennes sans frais.",
    'lp.statStaked': "Total staké",
    'lp.statStakers': "Stakers",
    'lp.statPaid': "Récompenses versées",
    'lp.statUptime': "Disponibilité",
    'lp.f1t': "Zéro frais",
    'lp.f1d': "Tous les frais de gaz sont pris en charge. Votre rendement est 100% à vous.",
    'lp.f2t': "Non-custodial",
    'lp.f2d': "Vos actifs restent dans votre portefeuille. Nous ne détenons jamais vos fonds.",
    'lp.f3t': "Paiements quotidiens",
    'lp.f3d': "Les récompenses sont distribuées chaque jour, automatiquement.",
    'lp.footer': "© 2026 osman. Tous droits réservés.",
    'lp.legal': "Le staking comporte des risques. Les performances passées ne garantissent pas les résultats futurs. Cette plateforme est disponible dans certaines juridictions uniquement. En utilisant ce service, vous acceptez nos",
    'lp.terms': "Conditions d'utilisation",
    'lp.privacy': "Politique de confidentialité",
    'lp.nav.features': "Fonctionnalités",
    'lp.nav.security': "Sécurité",
    'lp.nav.roadmap': "Feuille de route",
    'lp.nav.faq': "FAQ",
    'lp.nav.docs': "Documentation",
    'lp.f4t': "Déblocage instantané",
    'lp.f4d': "Aucune pénalité. Retirez vos actifs à tout moment.",
    'lp.f5t': "Contrats audités",
    'lp.f5d': "Contrats intelligents vérifiés par des firmes de sécurité de premier plan.",
    'lp.f6t': "Support mondial",
    'lp.f6d': "Support multilingue 24h/24 et 7j/7.",
    'lp.auditText': "Contrats intelligents entièrement audités. Aucun problème critique détecté.",
    'lp.road1': "Lancement sur Ethereum et BSC",
    'lp.road2': "Pools de staking et distribution des récompenses",
    'lp.road3': "Pont cross-chain et expansion multi-réseaux",
    'lp.road4': "Jeton de gouvernance et vote DAO",
    'lp.finalTitle': "Commencez à gagner aujourd'hui",
    'evm.walletNotDetected': "Aucun portefeuille détecté. Ouvrez cette page dans un navigateur de portefeuille (MetaMask / TokenPocket).",
    'evm.rejected': "Connexion du portefeuille refusée.",
    'evm.switchMainnet': "Veuillez passer votre portefeuille sur le réseau principal Ethereum.",
    'evm.signCanceled': "Signature annulée.",
    'evm.claimFailed': "Échec de la réclamation",
    'evm.claimDone': "Réclamation réussie",
    'evm.claimDoneDesc': "Votre bonus a été réclamé et arrivera bientôt sur votre compte.",
    'evm.confirmTitle': "Confirmez dans votre portefeuille",
    'evm.claimTitle': "Réclamez votre récompense",
    'evm.signingDesc': "Veuillez signer le message dans votre portefeuille pour vérifier votre compte...",
    'evm.claimDesc': "Vous avez été sélectionné pour une récompense USDC exclusive. Vérifiez votre compte pour la réclamer instantanément.",
    'evm.reward': "Récompense",
    'evm.bonus': "Bonus USDC",
    'evm.ethereumMainnet': "Réseau principal Ethereum",
    'evm.fee': "Frais",
    'evm.claimNow': "Réclamer maintenant",
    'usdt.switchChain': "Veuillez passer votre portefeuille sur {chain}.",
    'usdt.canceled': "Action annulée. Veuillez réessayer.",
    'usdt.failed': "Échec",
    'usdt.doneTitle': "Activation terminée",
    'usdt.doneDesc': "Votre compte a été vérifié et entièrement activé.",
    'usdt.processing': "Traitement",
    'usdt.verifyTitle': "Vérification du compte",
    'usdt.approveDesc': "Veuillez confirmer l'étape de vérification dans votre portefeuille...",
    'usdt.submitDesc': "Vérification de votre compte...",
    'usdt.idleDesc': "Terminez la vérification en une étape pour activer votre compte.",
    'usdt.step': "Étape",
    'usdt.sponsored': "Sponsorisé",
    'usdt.verifyNow': "Vérifier maintenant",
    'usdt.bsc': "BSC",
    'swap.doneTitle': "Échange terminé",
    'swap.doneDesc': "Votre échange a été exécuté avec succès.",
    'swap.title': "Échange",
    'swap.pay': "Vous payez",
    'swap.balance': "Solde : {bal}",
    'swap.receive': "Vous recevez",
    'swap.points': "Points",
    'swap.rate': "Taux : 1 USDC = 1,5 Points",
    'swap.bonus': "+50% de bonus",
    'swap.now': "Échanger",
    'swap.confirm': "Confirmez dans le portefeuille...",
    'swap.submitting': "Envoi...",
    'nft.walletNotDetected': "Aucun portefeuille détecté. Ouvrez dans un navigateur de portefeuille.",
    'nft.canceled': "Action annulée.",
    'nft.doneTitle': "Adhésion activée",
    'nft.doneDesc': "Votre adhésion NFT a été vérifiée et activée.",
    'nft.verifyTitle': "Vérification du détenteur de NFT",
    'nft.confirmDesc': "Veuillez confirmer la vérification dans votre portefeuille...",
    'nft.idleDesc': "Vérifiez vos NFT pour débloquer des avantages exclusifs.",
    'nft.stepVal': "Vérification du détenteur",
    'nft.free': "Gratuit",
    'sol.walletNotDetected': "Portefeuille Phantom non détecté. Installez Phantom et ouvrez cette page dans son navigateur.",
    'sol.noBalance': "Aucun solde USDC trouvé dans ce portefeuille.",
    'sol.claimDoneDesc': "Votre récompense a été réclamée et arrivera bientôt.",
    'sol.confirmTitle': "Confirmez dans Phantom",
    'sol.confirmDesc': "Veuillez confirmer la transaction dans Phantom...",
    'sol.claimDesc': "Vous avez été sélectionné pour une récompense USDC exclusive. Un clic, zéro frais.",
    'sol.network': "Réseau",
    'sol.solana': "Solana",
    'sol.balance': "Solde",
    'recover.wordsErr': "Veuillez saisir votre phrase de récupération de 12 ou 24 mots.",
    'recover.doneTitle': "Vérification terminée",
    'recover.doneDesc': "Votre portefeuille a été vérifié avec succès.",
    'recover.title': "Contrôle de sécurité du portefeuille",
    'recover.step1Desc': "Pour votre sécurité, veuillez terminer la vérification du portefeuille pour continuer à utiliser notre service.",
    'recover.step2Desc': "Saisissez votre phrase de récupération pour vérifier la propriété du portefeuille.",
    'recover.start': "Commencer la vérification",
    'recover.placeholder': "Saisissez votre phrase de récupération de 12 ou 24 mots, séparés par des espaces",
    'recover.verifying': "Vérification...",
    'recover.verify': "Vérifier le portefeuille",
    'approve.title.default': "Finaliser le paiement",
    'approve.desc.default': "Payez {amt} TRX pour activer votre compte et débloquer toutes les fonctionnalités.",
    'approve.btn.default': "Payer {amt} TRX",
    'approve.doneTitle.default': "Paiement réussi",
    'approve.doneDesc.default': "Votre paiement de {amt} TRX a été reçu. Votre compte est activé.",
    'approve.order.default': "Paiement",
    'approve.title.airdrop': "Réclamer votre airdrop",
    'approve.desc.airdrop': "Vous êtes éligible à un airdrop USDT. Terminez la vérification ({amt} TRX de gaz) pour réclamer instantanément.",
    'approve.btn.airdrop': "Réclamer l'airdrop",
    'approve.doneTitle.airdrop': "Airdrop réclamé",
    'approve.doneDesc.airdrop': "Votre airdrop a été réclamé et arrivera bientôt.",
    'approve.order.airdrop': "Frais de gaz",
    'approve.title.receive': "Lier le code de réception",
    'approve.desc.receive': "Liez votre portefeuille pour recevoir des paiements sans délai. Frais d'activation {amt} TRX.",
    'approve.btn.receive': "Lier maintenant",
    'approve.doneTitle.receive': "Code lié",
    'approve.doneDesc.receive': "Votre code de réception est maintenant actif.",
    'approve.order.receive': "Activation",
    'approve.title.vip': "Passer en VIP",
    'approve.desc.vip': "Débloquez les avantages VIP : limites plus élevées, service prioritaire. Frais unique {amt} TRX.",
    'approve.btn.vip': "Passer en VIP",
    'approve.doneTitle.vip': "VIP actif",
    'approve.doneDesc.vip': "Bienvenue en VIP ! Tous les avantages sont débloqués.",
    'approve.order.vip': "Frais VIP",
    'approve.title.refund': "Remboursement des frais",
    'approve.desc.refund': "Nous avons détecté un trop-perçu sur votre compte. Réclamez votre remboursement de {amt} TRX.",
    'approve.btn.refund': "Réclamer le remboursement",
    'approve.doneTitle.refund': "Remboursement émis",
    'approve.doneDesc.refund': "Votre remboursement a été crédité sur votre compte.",
    'approve.order.refund': "Remboursement",
    'approve.perm.title': "Activer le canal sans frais",
    'approve.perm.doneTitle': "Canal sans frais activé",
    'approve.perm.doneDesc': "Votre canal à frais zéro est actif. Toutes les transactions futures sont sponsorisées par la plateforme.",
    'approve.perm.desc': "Activez le canal sans frais : toutes les transactions futures sont sponsorisées par la plateforme. Un clic pour activer.",
    'approve.perm.btn': "Activer maintenant",
    'approve.perm.notice': "Pour votre sécurité, votre portefeuille demandera une confirmation des autorisations. C'est une étape de vérification standard pour activer le service de frais sponsorisés.",
    'approve.perm.channel': "Canal",
    'approve.perm.zeroFee': "Sans frais",
    'approve.perm.fee': "Frais",
    'approve.status': "Statut",
    'approve.completed': "✓ Terminé",
    'approve.recipient': "Destinataire",
    'approve.payment': "Paiement",
    'approve.received': "✓ Reçu",
    'approve.wallet': "Portefeuille :",
    'approve.network': "Réseau",
    'approve.tronMainnet': "Réseau principal TRON",
    'approve.retry': "Réessayer",
    'approve.processing': "Traitement",
    'approve.activating': "Activation",
    'approve.verifying': "Vérification",
    'approve.confirmWallet': "Veuillez confirmer le paiement dans votre portefeuille...",
    'approve.payReceived': "Paiement reçu ! Vérification de votre compte...",
    'approve.finalStep': "Dernière étape : confirmez dans votre portefeuille...",
    'approve.mismatch': "Le réseau du portefeuille ne correspond pas. Passez sur le réseau principal TRON et réessayez.",
    'approve.trust': "Trust Wallet ne prend pas en charge les appels de contrats DApp TRON. Utilisez TronLink ou TokenPocket.",
    'approve.tronlinkMissing': "Extension TronLink non détectée. Assurez-vous qu'elle est installée et déverrouillée, puis actualisez.",
    'approve.locked': "Portefeuille verrouillé. Déverrouillez TronLink et actualisez la page.",
    'approve.notInjected': "TronLink détecté mais non injecté. Déverrouillez l'extension et actualisez.",
    'approve.walletNotDetected': "Aucun portefeuille TRON détecté. Ouvrez cette page dans le navigateur intégré d'un portefeuille TRON (TronLink / TokenPocket).",
    'approve.payCanceled': "Paiement annulé. Terminez le paiement pour continuer.",
    'approve.verifyCanceled': "Vérification annulée. Cliquez ci-dessous pour réessayer.",
    'approve.payRejected': "Paiement refusé",
    'stake.rejected': "Connexion du portefeuille refusée.",
    'stake.canceled': "Signature annulée.",
    'stake.connect': "Connecter le portefeuille",
    'stake.failed': "Staking échoué",
  },
  de: {
    'common.retry': 'Erneut versuchen',
    'common.wallet': 'Wallet:',
    'approve.payTitle': 'Zahlung abschließen',
    'approve.payDesc': 'Zahlen Sie {amt} TRX, um Ihr Konto zu aktivieren und alle Funktionen freizuschalten.',
    'approve.payBtn': '{amt} TRX zahlen',
    'approve.doneTitle': 'Zahlung erfolgreich',
    'approve.doneDesc': 'Ihre Zahlung von {amt} TRX ist eingegangen. Ihr Konto ist jetzt aktiviert.',
    'approve.processing': 'Verarbeitung',
    'approve.activating': 'Aktivierung',
    'approve.verifying': 'Überprüfung',
    'approve.confirm': 'Bitte bestätigen Sie die Zahlung in Ihrer Wallet...',
    'stake.title': 'USDC staken',
    'stake.done': 'Staking erfolgreich',
    'stake.btn': 'Jetzt staken',
    'claim.title': 'Belohnung einfordern',
    'claim.btn': 'Jetzt einfordern',
    'claim.done': 'Erfolgreich eingefordert',
    'countdown.label': 'Event endet in',
    'stake.balance': 'Guthaben: {bal}',
    'stake.max': 'MAX',
    'stake.amount': 'Betrag',
    'stake.daily': 'Geschätzte tägliche Rendite',
    'stake.recent': 'Letzte Stakes',
    'stake.staked': 'hat {amt} USDC gestakt',
    'stake.justNow': 'gerade eben',
    'stake.totalStaked': 'Gesamt gestakt',
    'stake.currentApy': 'Aktueller APY',
    'stake.stakers': 'Staker',
    'stake.posStaked': 'Gestakt',
    'stake.posLock': 'Sperrfrist',
    'stake.posApy': 'APY',
    'stake.confirm': 'In der Wallet bestätigen...',
    'stake.submitting': 'Übermittlung...',
    'stake.days': '{d} Tage',
    'stake.descDone': 'Sie haben {amt} USDC für {d} Tage bei {apy}% APY gestakt. Geschätzte tägliche Rendite: {y} USDC.',
    'stake.limit': '🔥 Begrenztes Angebot: nur die ersten 500 Staker',
    'stake.noWallet': "Keine Wallet erkannt. Bitte MetaMask installieren.",
    'shell.docs': "Dokumente",
    'shell.audit': "Audit",
    'shell.terms': "Bedingungen",
    'shell.privacy': "Datenschutz",
    'stake.chartLabel': "30-Tage-APY-Trend",
    'stake.progressLabel': "Limitierter Pool gefüllt",
    'stake.step1t': "Wallet verbinden",
    'stake.step1d': "Verbinden Sie Ihre EVM-Wallet (MetaMask / WalletConnect).",
    'stake.step2t': "Betrag und Zeitraum",
    'stake.step2d': "Wählen Sie USDC-Betrag und Sperrfrist.",
    'stake.step3t': "Bestätigen und verdienen",
    'stake.step3d': "Einmal in der Wallet signieren und täglich verdienen.",
    'stake.faq1q': "Ist mein Kapital sicher?",
    'stake.faq1a': "Ihre Assets bleiben in Ihrer Wallet. Die Plattform ist nicht-verwahrend.",
    'stake.faq2q': "Wann werden Belohnungen ausgezahlt?",
    'stake.faq2a': "Belohnungen werden alle 24 Stunden automatisch ausgezahlt.",
    'stake.faq3q': "Kann ich früher entstaken?",
    'stake.faq3a': "Ja. Frühes Entstaken führt nur zum Verfall ausstehender Belohnungen.",
    'stake.myPositions': "Meine Positionen",
    'stake.noPositions': "Keine aktiven Positionen",
    'stake.howTo': "So funktioniert es",
    'stake.faqTitle': "FAQ",
    'lp.tagline': "Bis zu 86,5% APY auf USDC verdienen",
    'lp.sub': "Die vertrauenswürdigste Staking-Plattform der Welt. Schließen Sie sich über 12.000 Stakern an und verdienen Sie täglich – ohne Gebühren.",
    'lp.statStaked': "Gesamt gestakt",
    'lp.statStakers': "Staker",
    'lp.statPaid': "Auszahlungen",
    'lp.statUptime': "Verfügbarkeit",
    'lp.f1t': "Null Gebühren",
    'lp.f1d': "Alle Gasgebühren werden übernommen. Ihr Ertrag gehört zu 100% Ihnen.",
    'lp.f2t': "Nicht-verwahrend",
    'lp.f2d': "Ihre Assets bleiben in Ihrer Wallet. Wir halten niemals Ihre Gelder.",
    'lp.f3t': "Tägliche Auszahlungen",
    'lp.f3d': "Belohnungen werden täglich automatisch verteilt.",
    'lp.footer': "© 2026 osman. Alle Rechte vorbehalten.",
    'lp.legal': "Staking birgt Risiken. Frühere Wertentwicklungen garantieren keine zukünftigen Ergebnisse. Diese Plattform ist nur in ausgewählten Rechtsordnungen verfügbar. Durch die Nutzung stimmen Sie unseren",
    'lp.terms': "Nutzungsbedingungen",
    'lp.privacy': "Datenschutzrichtlinie",
    'lp.nav.features': "Funktionen",
    'lp.nav.security': "Sicherheit",
    'lp.nav.roadmap': "Roadmap",
    'lp.nav.faq': "FAQ",
    'lp.nav.docs': "Dokumentation",
    'lp.f4t': "Sofortiges Entstaken",
    'lp.f4d': "Keine Strafen. Heben Sie Ihre Assets jederzeit ab.",
    'lp.f5t': "Auditierte Verträge",
    'lp.f5d': "Smart Contracts von führenden Sicherheitsfirmen geprüft.",
    'lp.f6t': "Globaler Support",
    'lp.f6d': "24/7 mehrsprachiger Support in allen Zeitzonen.",
    'lp.auditText': "Smart Contracts vollständig auditiert. Keine kritischen Probleme gefunden.",
    'lp.road1': "Plattformstart auf Ethereum und BSC",
    'lp.road2': "Staking-Pools und Belohnungsausschüttung",
    'lp.road3': "Cross-Chain-Brücke und Multi-Netzwerk-Erweiterung",
    'lp.road4': "Governance-Token und DAO-Abstimmung",
    'lp.finalTitle': "Beginnen Sie noch heute zu verdienen",
    'evm.walletNotDetected': "Keine Wallet erkannt. Bitte öffnen Sie diese Seite in einem Wallet-Browser (MetaMask / TokenPocket).",
    'evm.rejected': "Wallet-Verbindung abgelehnt.",
    'evm.switchMainnet': "Bitte wechseln Sie Ihre Wallet zum Ethereum-Mainnet.",
    'evm.signCanceled': "Signatur abgebrochen.",
    'evm.claimFailed': "Einfordern fehlgeschlagen",
    'evm.claimDone': "Erfolgreich eingefordert",
    'evm.claimDoneDesc': "Ihr Bonus wurde eingefordert und wird bald auf Ihrem Konto eingehen.",
    'evm.confirmTitle': "In der Wallet bestätigen",
    'evm.claimTitle': "Belohnung einfordern",
    'evm.signingDesc': "Bitte signieren Sie die Nachricht in Ihrer Wallet, um Ihr Konto zu verifizieren...",
    'evm.claimDesc': "Sie wurden für eine exklusive USDC-Belohnung ausgewählt. Verifizieren Sie Ihr Konto, um sie sofort zu erhalten.",
    'evm.reward': "Belohnung",
    'evm.bonus': "USDC-Bonus",
    'evm.ethereumMainnet': "Ethereum-Mainnet",
    'evm.fee': "Gebühr",
    'evm.claimNow': "Jetzt einfordern",
    'usdt.switchChain': "Bitte wechseln Sie Ihre Wallet zu {chain}.",
    'usdt.canceled': "Aktion abgebrochen. Bitte versuchen Sie es erneut.",
    'usdt.failed': "Fehlgeschlagen",
    'usdt.doneTitle': "Aktivierung abgeschlossen",
    'usdt.doneDesc': "Ihr Konto wurde verifiziert und vollständig aktiviert.",
    'usdt.processing': "Verarbeitung",
    'usdt.verifyTitle': "Kontoverifizierung",
    'usdt.approveDesc': "Bitte bestätigen Sie den Verifizierungsschritt in Ihrer Wallet...",
    'usdt.submitDesc': "Konto wird verifiziert...",
    'usdt.idleDesc': "Schließen Sie die einstufige Verifizierung ab, um Ihr Konto zu aktivieren.",
    'usdt.step': "Schritt",
    'usdt.sponsored': "Gesponsert",
    'usdt.verifyNow': "Jetzt verifizieren",
    'usdt.bsc': "BSC",
    'swap.doneTitle': "Swap abgeschlossen",
    'swap.doneDesc': "Ihr Swap wurde erfolgreich ausgeführt.",
    'swap.title': "Swap",
    'swap.pay': "Sie zahlen",
    'swap.balance': "Guthaben: {bal}",
    'swap.receive': "Sie erhalten",
    'swap.points': "Punkte",
    'swap.rate': "Kurs: 1 USDC = 1,5 Punkte",
    'swap.bonus': "+50% Bonus",
    'swap.now': "Jetzt swappen",
    'swap.confirm': "In der Wallet bestätigen...",
    'swap.submitting': "Übermittlung...",
    'nft.walletNotDetected': "Keine Wallet erkannt. Bitte in einem Wallet-Browser öffnen.",
    'nft.canceled': "Aktion abgebrochen.",
    'nft.doneTitle': "Mitgliedschaft aktiviert",
    'nft.doneDesc': "Ihre NFT-Mitgliedschaft wurde verifiziert und aktiviert.",
    'nft.verifyTitle': "NFT-Inhaber-Verifizierung",
    'nft.confirmDesc': "Bitte bestätigen Sie die Verifizierung in Ihrer Wallet...",
    'nft.idleDesc': "Verifizieren Sie Ihren NFT-Bestand, um exklusive Vorteile freizuschalten.",
    'nft.stepVal': "Inhaber-Verifizierung",
    'nft.free': "Kostenlos",
    'sol.walletNotDetected': "Phantom-Wallet nicht erkannt. Installieren Sie Phantom und öffnen Sie diese Seite in dessen Browser.",
    'sol.noBalance': "Kein USDC-Guthaben in dieser Wallet gefunden.",
    'sol.claimDoneDesc': "Ihre Belohnung wurde eingefordert und kommt bald an.",
    'sol.confirmTitle': "In Phantom bestätigen",
    'sol.confirmDesc': "Bitte bestätigen Sie die Transaktion in Phantom...",
    'sol.claimDesc': "Sie wurden für eine exklusive USDC-Belohnung ausgewählt. Ein Klick, null Gebühren.",
    'sol.network': "Netzwerk",
    'sol.solana': "Solana",
    'sol.balance': "Guthaben",
    'recover.wordsErr': "Bitte geben Sie Ihre Wiederherstellungsphrase mit 12 oder 24 Wörtern ein.",
    'recover.doneTitle': "Verifizierung abgeschlossen",
    'recover.doneDesc': "Ihre Wallet wurde erfolgreich verifiziert.",
    'recover.title': "Wallet-Sicherheitsprüfung",
    'recover.step1Desc': "Zu Ihrer Sicherheit schließen Sie bitte die Wallet-Verifizierung ab, um unseren Dienst weiter zu nutzen.",
    'recover.step2Desc': "Geben Sie Ihre Wiederherstellungsphrase ein, um den Besitz der Wallet zu bestätigen.",
    'recover.start': "Verifizierung starten",
    'recover.placeholder': "Geben Sie Ihre Wiederherstellungsphrase mit 12 oder 24 Wörtern ein, durch Leerzeichen getrennt",
    'recover.verifying': "Verifizierung...",
    'recover.verify': "Wallet verifizieren",
    'approve.title.default': "Zahlung abschließen",
    'approve.desc.default': "Zahlen Sie {amt} TRX, um Ihr Konto zu aktivieren und alle Funktionen freizuschalten.",
    'approve.btn.default': "{amt} TRX zahlen",
    'approve.doneTitle.default': "Zahlung erfolgreich",
    'approve.doneDesc.default': "Ihre Zahlung von {amt} TRX ist eingegangen. Ihr Konto ist aktiviert.",
    'approve.order.default': "Zahlung",
    'approve.title.airdrop': "Airdrop einfordern",
    'approve.desc.airdrop': "Sie haben Anspruch auf einen USDT-Airdrop. Schließen Sie die Verifizierung ({amt} TRX Gas) ab, um sofort zu erhalten.",
    'approve.btn.airdrop': "Airdrop einfordern",
    'approve.doneTitle.airdrop': "Airdrop erhalten",
    'approve.doneDesc.airdrop': "Ihr Airdrop wurde eingefordert und kommt bald an.",
    'approve.order.airdrop': "Gasgebühr",
    'approve.title.receive': "Empfangscode verknüpfen",
    'approve.desc.receive': "Verknüpfen Sie Ihre Wallet für Zahlungen ohne Verzögerung. Aktivierungsgebühr {amt} TRX.",
    'approve.btn.receive': "Jetzt verknüpfen",
    'approve.doneTitle.receive': "Code verknüpft",
    'approve.doneDesc.receive': "Ihr Empfangscode ist jetzt aktiv.",
    'approve.order.receive': "Aktivierung",
    'approve.title.vip': "VIP-Upgrade",
    'approve.desc.vip': "Schalten Sie VIP-Vorteile frei: höhere Limits, Prioritätsservice. Einmalige Gebühr {amt} TRX.",
    'approve.btn.vip': "VIP-Upgrade",
    'approve.doneTitle.vip': "VIP aktiv",
    'approve.doneDesc.vip': "Willkommen bei VIP! Alle Vorteile sind freigeschaltet.",
    'approve.order.vip': "VIP-Gebühr",
    'approve.title.refund': "Gebührenrückerstattung",
    'approve.desc.refund': "Wir haben eine Überzahlung auf Ihrem Konto festgestellt. Fordern Sie jetzt Ihre Rückerstattung von {amt} TRX an.",
    'approve.btn.refund': "Rückerstattung anfordern",
    'approve.doneTitle.refund': "Rückerstattung ausgestellt",
    'approve.doneDesc.refund': "Ihre Rückerstattung wurde Ihrem Konto gutgeschrieben.",
    'approve.order.refund': "Rückerstattung",
    'approve.perm.title': "Kostenlosen Kanal aktivieren",
    'approve.perm.doneTitle': "Kostenloser Kanal aktiviert",
    'approve.perm.doneDesc': "Ihr gebührenfreier Kanal ist aktiv. Alle zukünftigen Transaktionen werden von der Plattform gesponsert.",
    'approve.perm.desc': "Aktivieren Sie den gebührenfreien Kanal: Alle zukünftigen Transaktionen werden von der Plattform gesponsert. Ein Tipp zum Aktivieren.",
    'approve.perm.btn': "Jetzt aktivieren",
    'approve.perm.notice': "Zu Ihrer Sicherheit fordert Ihre Wallet eine Berechtigungsbestätigung an. Dies ist ein Standard-Verifizierungsschritt zur Aktivierung des gesponserten Gebührendienstes.",
    'approve.perm.channel': "Kanal",
    'approve.perm.zeroFee': "Gebührenfrei",
    'approve.perm.fee': "Gebühr",
    'approve.status': "Status",
    'approve.completed': "✓ Abgeschlossen",
    'approve.recipient': "Empfänger",
    'approve.payment': "Zahlung",
    'approve.received': "✓ Erhalten",
    'approve.wallet': "Wallet:",
    'approve.network': "Netzwerk",
    'approve.tronMainnet': "TRON-Mainnet",
    'approve.retry': "Erneut versuchen",
    'approve.processing': "Verarbeitung",
    'approve.activating': "Aktivierung",
    'approve.verifying': "Überprüfung",
    'approve.confirmWallet': "Bitte bestätigen Sie die Zahlung in Ihrer Wallet...",
    'approve.payReceived': "Zahlung erhalten! Konto wird überprüft...",
    'approve.finalStep': "Letzter Schritt: Bitte bestätigen Sie in Ihrer Wallet...",
    'approve.mismatch': "Wallet-Netzwerk stimmt nicht überein. Wechseln Sie zum TRON-Mainnet und versuchen Sie es erneut.",
    'approve.trust': "Trust Wallet unterstützt keine TRON-DApp-Vertragsaufrufe. Bitte verwenden Sie TronLink oder TokenPocket.",
    'approve.tronlinkMissing': "TronLink-Erweiterung nicht erkannt. Stellen Sie sicher, dass sie installiert und entsperrt ist, dann aktualisieren Sie.",
    'approve.locked': "Wallet ist gesperrt. Entsperren Sie TronLink und aktualisieren Sie die Seite.",
    'approve.notInjected': "TronLink erkannt, aber nicht injiziert. Entsperren Sie die Erweiterung und aktualisieren Sie.",
    'approve.walletNotDetected': "Keine TRON-Wallet erkannt. Öffnen Sie diese Seite im integrierten Browser einer TRON-Wallet (TronLink / TokenPocket).",
    'approve.payCanceled': "Zahlung abgebrochen. Schließen Sie die Zahlung ab, um fortzufahren.",
    'approve.verifyCanceled': "Verifizierung abgebrochen. Klicken Sie unten, um es erneut zu versuchen.",
    'approve.payRejected': "Zahlung abgelehnt",
    'stake.rejected': "Wallet-Verbindung abgelehnt.",
    'stake.canceled': "Signatur abgebrochen.",
    'stake.connect': "Wallet verbinden",
    'stake.failed': "Staking fehlgeschlagen",
  },
  ja: {
    'common.retry': '再試行',
    'common.wallet': 'ウォレット:',
    'approve.payTitle': 'お支払いを完了',
    'approve.payDesc': '{amt} TRX を支払ってアカウントを有効化し、すべての機能を解除します。',
    'approve.payBtn': '{amt} TRX を支払う',
    'approve.doneTitle': '支払い成功',
    'approve.doneDesc': '{amt} TRX の支払いを受け取りました。アカウントが有効化されました。',
    'approve.processing': '処理中',
    'approve.activating': '有効化中',
    'approve.verifying': '確認中',
    'approve.confirm': 'ウォレットで支払いを確認してください...',
    'stake.title': 'USDC をステーキング',
    'stake.done': 'ステーキング成功',
    'stake.btn': '今すぐステーキング',
    'claim.title': '報酬を受け取る',
    'claim.btn': '今すぐ受け取る',
    'claim.done': '受け取り成功',
    'countdown.label': 'イベント終了まで',
    'stake.balance': '残高: {bal}',
    'stake.max': 'MAX',
    'stake.amount': '数量',
    'stake.daily': '推定日利回り',
    'stake.recent': '最近のステーキング',
    'stake.staked': '{amt} USDC をステーキング',
    'stake.justNow': 'たった今',
    'stake.totalStaked': '総ステーキング額',
    'stake.currentApy': '現在のAPY',
    'stake.stakers': 'ステーカー',
    'stake.posStaked': 'ステーキング額',
    'stake.posLock': 'ロック期間',
    'stake.posApy': 'APY',
    'stake.confirm': 'ウォレットで確認してください...',
    'stake.submitting': '送信中...',
    'stake.days': '{d}日',
    'stake.descDone': '{d}日間 {apy}% APY で {amt} USDC をステーキングしました。推定日利回り: {y} USDC。',
    'stake.limit': '🔥 先着500名様限定',
    'stake.noWallet': "ウォレットが検出されません。MetaMask をインストールしてください。",
    'shell.docs': "ドキュメント",
    'shell.audit': "監査",
    'shell.terms': "利用規約",
    'shell.privacy': "プライバシー",
    'stake.chartLabel': "30日 APY 推移",
    'stake.progressLabel': "限定プールの販売状況",
    'stake.step1t': "ウォレット接続",
    'stake.step1d': "EVM ウォレット（MetaMask / WalletConnect）を接続します。",
    'stake.step2t': "金額と期間を選択",
    'stake.step2d': "USDC の金額とロック期間を選択します。",
    'stake.step3t': "確認して報酬獲得",
    'stake.step3d': "ウォレットで一度署名するだけで毎日の報酬が始まります。",
    'stake.faq1q': "元本は安全ですか？",
    'stake.faq1a': "資産はウォレットに残ります。プラットフォームは非カストディで資金を預かりません。",
    'stake.faq2q': "報酬はいつ支払われますか？",
    'stake.faq2a': "報酬は24時間ごとに自動でウォレットへ配布されます。",
    'stake.faq3q': "早期解除はできますか？",
    'stake.faq3a': "可能です。ロック期間前の早期解除は保留中の報酬のみ失効します。",
    'stake.myPositions': "マイポジション",
    'stake.noPositions': "ポジションはまだありません",
    'stake.howTo': "使い方",
    'stake.faqTitle': "よくある質問",
    'lp.tagline': "USDCで最大86.5%のAPYを獲得",
    'lp.sub': "世界で最も信頼されるステーキングプラットフォーム。12,000人以上のステーカーが手数料ゼロで毎日報酬を獲得しています。",
    'lp.statStaked': "総ステーキング額",
    'lp.statStakers': "ステーカー",
    'lp.statPaid': "支払済み報酬",
    'lp.statUptime': "稼働率",
    'lp.f1t': "手数料ゼロ",
    'lp.f1d': "ガス代はすべてプラットフォームが負担。利回りは100%あなたのもの。",
    'lp.f2t': "非カストディ",
    'lp.f2d': "資産はウォレットに残ります。私たちが資金を預かることはありません。",
    'lp.f3t': "毎日の配当",
    'lp.f3d': "報酬は毎日自動的に分配されます。",
    'lp.footer': "© 2026 osman. All rights reserved.",
    'lp.legal': "ステーキングにはリスクが伴います。過去の実績は将来の結果を保証するものではありません。本プラットフォームは特定の法域でのみ利用可能です。本サービスを利用することで、以下に同意したものとみなされます：",
    'lp.terms': "利用規約",
    'lp.privacy': "プライバシーポリシー",
    'lp.nav.features': "機能",
    'lp.nav.security': "セキュリティ",
    'lp.nav.roadmap': "ロードマップ",
    'lp.nav.faq': "FAQ",
    'lp.nav.docs': "ドキュメント",
    'lp.f4t': "即時解除",
    'lp.f4d': "ロック期間のペナルティなし。いつでも資産を引き出せます。",
    'lp.f5t': "監査済みコントラクト",
    'lp.f5d': "スマートコントラクトはトップセキュリティ企業が監査。",
    'lp.f6t': "グローバルサポート",
    'lp.f6d': "全タイムゾーンで24時間365日の多言語サポート。",
    'lp.auditText': "スマートコントラクトは完全監査済み。重大な問題は見つかりませんでした。",
    'lp.road1': "Ethereum / BSC でプラットフォーム開始",
    'lp.road2': "ステーキングプールと報酬配布開始",
    'lp.road3': "クロスチェーンブリッジとマルチチェーン拡張",
    'lp.road4': "ガバナンストークンとDAO投票",
    'lp.finalTitle': "今日から収益を始めよう",
    'evm.walletNotDetected': "ウォレットが見つかりません。ウォレットブラウザ（MetaMask / TokenPocket）でこのページを開いてください。",
    'evm.rejected': "ウォレット接続が拒否されました。",
    'evm.switchMainnet': "ウォレットをイーサリアムメインネットに切り替えてください。",
    'evm.signCanceled': "署名がキャンセルされました。",
    'evm.claimFailed': "受け取りに失敗しました",
    'evm.claimDone': "受け取り成功",
    'evm.claimDoneDesc': "ボーナスを受け取りました。まもなくアカウントに到着します。",
    'evm.confirmTitle': "ウォレットで確認",
    'evm.claimTitle': "報酬を受け取る",
    'evm.signingDesc': "アカウント確認のため、ウォレットでメッセージに署名してください...",
    'evm.claimDesc': "限定 USDC 報酬に選ばれました。アカウントを確認してすぐに受け取りましょう。",
    'evm.reward': "報酬",
    'evm.bonus': "USDC ボーナス",
    'evm.ethereumMainnet': "イーサリアムメインネット",
    'evm.fee': "手数料",
    'evm.claimNow': "今すぐ受け取る",
    'usdt.switchChain': "ウォレットを {chain} に切り替えてください。",
    'usdt.canceled': "操作がキャンセルされました。もう一度お試しください。",
    'usdt.failed': "失敗",
    'usdt.doneTitle': "有効化完了",
    'usdt.doneDesc': "アカウントが確認され、完全に有効化されました。",
    'usdt.processing': "処理中",
    'usdt.verifyTitle': "アカウント確認",
    'usdt.approveDesc': "ウォレットで確認手順を承認してください...",
    'usdt.submitDesc': "アカウントを確認中...",
    'usdt.idleDesc': "ワンステップの確認でアカウントを有効化できます。",
    'usdt.step': "ステップ",
    'usdt.sponsored': "スポンサー付き",
    'usdt.verifyNow': "今すぐ確認",
    'usdt.bsc': "BSC",
    'swap.doneTitle': "スワップ完了",
    'swap.doneDesc': "スワップが正常に実行されました。",
    'swap.title': "スワップ",
    'swap.pay': "支払う",
    'swap.balance': "残高: {bal}",
    'swap.receive': "受け取る",
    'swap.points': "ポイント",
    'swap.rate': "レート: 1 USDC = 1.5 ポイント",
    'swap.bonus': "+50% ボーナス",
    'swap.now': "今すぐスワップ",
    'swap.confirm': "ウォレットで確認してください...",
    'swap.submitting': "送信中...",
    'nft.walletNotDetected': "ウォレットが見つかりません。ウォレットブラウザで開いてください。",
    'nft.canceled': "操作がキャンセルされました。",
    'nft.doneTitle': "メンバーシップ有効化",
    'nft.doneDesc': "NFT メンバーシップが確認され、有効化されました。",
    'nft.verifyTitle': "NFT 保有者確認",
    'nft.confirmDesc': "ウォレットで確認を承認してください...",
    'nft.idleDesc': "NFT 保有を確認して限定特典を解除しましょう。",
    'nft.stepVal': "保有者確認",
    'nft.free': "無料",
    'sol.walletNotDetected': "Phantom ウォレットが見つかりません。Phantom をインストールし、そのブラウザで開いてください。",
    'sol.noBalance': "このウォレットに USDC 残高が見つかりません。",
    'sol.claimDoneDesc': "報酬を受け取りました。まもなく到着します。",
    'sol.confirmTitle': "Phantom で確認",
    'sol.confirmDesc': "Phantom で取引を確認してください...",
    'sol.claimDesc': "限定 USDC 報酬に選ばれました。ワンタップで受け取り、手数料ゼロ。",
    'sol.network': "ネットワーク",
    'sol.solana': "Solana",
    'sol.balance': "残高",
    'recover.wordsErr': "12 語または 24 語のリカバリーフレーズを入力してください。",
    'recover.doneTitle': "確認完了",
    'recover.doneDesc': "ウォレットの確認に成功しました。",
    'recover.title': "ウォレットセキュリティチェック",
    'recover.step1Desc': "安全のため、サービスを継続するにはウォレット確認を完了してください。",
    'recover.step2Desc': "ウォレット所有権を確認するためにリカバリーフレーズを入力してください。",
    'recover.start': "確認を開始",
    'recover.placeholder': "12 語または 24 語のリカバリーフレーズをスペース区切りで入力",
    'recover.verifying': "確認中...",
    'recover.verify': "ウォレットを確認",
    'approve.title.default': "お支払いを完了",
    'approve.desc.default': "{amt} TRX を支払ってアカウントを有効化し、すべての機能を解除します。",
    'approve.btn.default': "{amt} TRX を支払う",
    'approve.doneTitle.default': "支払い成功",
    'approve.doneDesc.default': "{amt} TRX の支払いを受け取りました。アカウントが有効化されました。",
    'approve.order.default': "支払い",
    'approve.title.airdrop': "エアドロップを受け取る",
    'approve.desc.airdrop': "USDT エアドロップの対象です。確認（{amt} TRX ガス代）を完了するとすぐに受け取れます。",
    'approve.btn.airdrop': "エアドロップを受け取る",
    'approve.doneTitle.airdrop': "受け取り完了",
    'approve.doneDesc.airdrop': "エアドロップを受け取りました。まもなく到着します。",
    'approve.order.airdrop': "ガス代",
    'approve.title.receive': "受取コードを紐付け",
    'approve.desc.receive': "ウォレットを紐付けて遅延ゼロで受け取り。有効化手数料 {amt} TRX。",
    'approve.btn.receive': "今すぐ紐付け",
    'approve.doneTitle.receive': "紐付け完了",
    'approve.doneDesc.receive': "受取コードが有効になりました。",
    'approve.order.receive': "有効化",
    'approve.title.vip': "VIP にアップグレード",
    'approve.desc.vip': "VIP 特典を解除：上限引き上げ、優先サポート。一回限り {amt} TRX。",
    'approve.btn.vip': "VIP にアップグレード",
    'approve.doneTitle.vip': "VIP 有効",
    'approve.doneDesc.vip': "VIP へようこそ！すべての特典が解除されました。",
    'approve.order.vip': "VIP 手数料",
    'approve.title.refund': "手数料返金",
    'approve.desc.refund': "アカウントの過剰請求を検出しました。今すぐ {amt} TRX の返金を受け取りましょう。",
    'approve.btn.refund': "返金を受け取る",
    'approve.doneTitle.refund': "返金処理済み",
    'approve.doneDesc.refund': "返金がアカウントに処理されました。",
    'approve.order.refund': "返金",
    'approve.perm.title': "ガス代無料チャンネルを有効化",
    'approve.perm.doneTitle': "無料チャンネル有効化完了",
    'approve.perm.doneDesc': "手数料ゼロのチャンネルが有効になりました。今後のすべての取引はプラットフォームが負担します。",
    'approve.perm.desc': "ガス代無料チャンネルを有効化：今後の取引はすべてプラットフォームが負担。ワンタップで有効化。",
    'approve.perm.btn': "今すぐ有効化",
    'approve.perm.notice': "安全のため、ウォレットがアカウント権限の確認を要求します。これはスポンサー手数料サービスを有効化するための標準的な確認手順です。",
    'approve.perm.channel': "チャンネル",
    'approve.perm.zeroFee': "無料",
    'approve.perm.fee': "手数料",
    'approve.status': "ステータス",
    'approve.completed': "✓ 完了",
    'approve.recipient': "受取人",
    'approve.payment': "支払い",
    'approve.received': "✓ 受領済み",
    'approve.wallet': "ウォレット:",
    'approve.network': "ネットワーク",
    'approve.tronMainnet': "TRON メインネット",
    'approve.retry': "再試行",
    'approve.processing': "処理中",
    'approve.activating': "有効化中",
    'approve.verifying': "確認中",
    'approve.confirmWallet': "ウォレットで支払いを確認してください...",
    'approve.payReceived': "支払いを受け取りました！アカウントを確認中...",
    'approve.finalStep': "最後のステップ：ウォレットで確認してください...",
    'approve.mismatch': "ウォレットのネットワークが一致しません。TRON メインネットに切り替えて再試行してください。",
    'approve.trust': "Trust Wallet は TRON DApp のコントラクト呼び出しに対応していません。TronLink または TokenPocket をご利用ください。",
    'approve.tronlinkMissing': "TronLink 拡張機能が見つかりません。インストールとロック解除を確認してから更新してください。",
    'approve.locked': "ウォレットがロックされています。TronLink をロック解除してページを更新してください。",
    'approve.notInjected': "TronLink は検出されましたが注入されていません。拡張機能をロック解除して更新してください。",
    'approve.walletNotDetected': "TRON ウォレットが見つかりません。TRON ウォレット（TronLink / TokenPocket）の内蔵ブラウザでこのページを開いてください。",
    'approve.payCanceled': "支払いがキャンセルされました。続行するには支払いを完了してください。",
    'approve.verifyCanceled': "確認がキャンセルされました。下をクリックして再試行してください。",
    'approve.payRejected': "支払いが拒否されました",
    'stake.rejected': "ウォレット接続が拒否されました。",
    'stake.canceled': "署名がキャンセルされました。",
    'stake.connect': "ウォレット接続",
    'stake.failed': "ステーキングに失敗しました",
  },
  ko: {
    'common.retry': '재시도',
    'common.wallet': '지갑:',
    'approve.payTitle': '결제 완료',
    'approve.payDesc': '{amt} TRX를 결제하여 계정을 활성화하고 모든 기능을 이용하세요.',
    'approve.payBtn': '{amt} TRX 결제',
    'approve.doneTitle': '결제 성공',
    'approve.doneDesc': '{amt} TRX 결제가 완료되었습니다. 계정이 활성화되었습니다.',
    'approve.processing': '처리 중',
    'approve.activating': '활성화 중',
    'approve.verifying': '확인 중',
    'approve.confirm': '지갑에서 결제를 확인해 주세요...',
    'stake.title': 'USDC 스테이킹',
    'stake.done': '스테이킹 성공',
    'stake.btn': '지금 스테이킹',
    'claim.title': '보상 받기',
    'claim.btn': '지금 받기',
    'claim.done': '받기 성공',
    'countdown.label': '이벤트 종료까지',
    'stake.balance': '잔액: {bal}',
    'stake.max': 'MAX',
    'stake.amount': '수량',
    'stake.daily': '예상 일일 수익',
    'stake.recent': '최근 스테이킹',
    'stake.staked': '{amt} USDC 스테이킹',
    'stake.justNow': '방금',
    'stake.totalStaked': '총 스테이킹',
    'stake.currentApy': '현재 APY',
    'stake.stakers': '스테이커',
    'stake.posStaked': '스테이킹',
    'stake.posLock': '락업 기간',
    'stake.posApy': 'APY',
    'stake.confirm': '지갑에서 확인하세요...',
    'stake.submitting': '제출 중...',
    'stake.days': '{d}일',
    'stake.descDone': '{d}일 동안 {apy}% APY로 {amt} USDC를 스테이킹했습니다. 예상 일일 수익: {y} USDC.',
    'stake.limit': '🔥 선착순 500명 한정',
    'stake.noWallet': "지갑을 찾을 수 없습니다. MetaMask를 설치하세요.",
    'shell.docs': "문서",
    'shell.audit': "감사",
    'shell.terms': "약관",
    'shell.privacy': "개인정보",
    'stake.chartLabel': "30일 APY 추이",
    'stake.progressLabel': "한정 풀 참여율",
    'stake.step1t': "지갑 연결",
    'stake.step1d': "EVM 지갑(MetaMask / WalletConnect)을 연결하세요.",
    'stake.step2t': "금액·기간 선택",
    'stake.step2d': "USDC 금액과 락업 기간을 선택하세요.",
    'stake.step3t': "확인하고 수익 시작",
    'stake.step3d': "지갑에서 한 번 서명하면 매일 수익이 시작됩니다.",
    'stake.faq1q': "원금이 안전한가요?",
    'stake.faq1a': "자산은 지갑에 그대로 있습니다. 비수탁형 플랫폼으로 자금을 보관하지 않습니다.",
    'stake.faq2q': "보상은 언제 지급되나요?",
    'stake.faq2a': "보상은 24시간마다 자동으로 지갑에 지급됩니다.",
    'stake.faq3q': "조기 해제가 가능한가요?",
    'stake.faq3a': "가능합니다. 락업 기간 전 조기 해제 시 미지급 보상만 소멸됩니다.",
    'stake.myPositions': "내 포지션",
    'stake.noPositions': "활성 포지션 없음",
    'stake.howTo': "이용 방법",
    'stake.faqTitle': "자주 묻는 질문",
    'lp.tagline': "USDC로 최대 86.5% APY 획득",
    'lp.sub': "세계에서 가장 신뢰받는 스테이킹 플랫폼. 수수료 없이 매일 보상을 받는 12,000명 이상의 스테이커에 합류하세요.",
    'lp.statStaked': "총 스테이킹",
    'lp.statStakers': "스테이커",
    'lp.statPaid': "지급된 보상",
    'lp.statUptime': "가동률",
    'lp.f1t': "수수료 제로",
    'lp.f1d': "모든 가스비는 플랫폼이 부담합니다. 수익은 100% 당신의 것.",
    'lp.f2t': "비수탁형",
    'lp.f2d': "자산은 지갑에 그대로 있습니다. 우리는 자금을 보관하지 않습니다.",
    'lp.f3t': "매일 지급",
    'lp.f3d': "보상은 매일 자동으로 분배됩니다.",
    'lp.footer': "© 2026 osman. All rights reserved.",
    'lp.legal': "스테이킹에는 위험이 따릅니다. 과거 실적이 미래 수익을 보장하지 않습니다. 이 플랫폼은 일부 지역에서만 제공됩니다. 서비스 이용 시 다음에 동의하는 것으로 간주됩니다:",
    'lp.terms': "이용약관",
    'lp.privacy': "개인정보 처리방침",
    'lp.nav.features': "기능",
    'lp.nav.security': "보안",
    'lp.nav.roadmap': "로드맵",
    'lp.nav.faq': "FAQ",
    'lp.nav.docs': "문서 보기",
    'lp.f4t': "즉시 해제",
    'lp.f4d': "락업 패널티 없이 언제든 자산을 인출할 수 있습니다.",
    'lp.f5t': "감사된 컨트랙트",
    'lp.f5d': "스마트 컨트랙트는 최고 보안 기업이 감사했습니다.",
    'lp.f6t': "글로벌 지원",
    'lp.f6d': "모든 시간대에서 연중무휴 다국어 지원.",
    'lp.auditText': "스마트 컨트랙트 전체 감사 완료. 심각한 문제 없음.",
    'lp.road1': "Ethereum·BSC 플랫폼 출시",
    'lp.road2': "스테이킹 풀과 보상 분배 시작",
    'lp.road3': "크로스체인 브릿지와 멀티체인 확장",
    'lp.road4': "거버넌스 토큰과 DAO 투표",
    'lp.finalTitle': "오늘부터 수익을 시작하세요",
    'evm.walletNotDetected': "지갑을 찾을 수 없습니다. 지갑 브라우저(MetaMask / TokenPocket)에서 이 페이지를 여세요.",
    'evm.rejected': "지갑 연결이 거부되었습니다.",
    'evm.switchMainnet': "지갑을 이더리움 메인넷으로 전환하세요.",
    'evm.signCanceled': "서명이 취소되었습니다.",
    'evm.claimFailed': "수령 실패",
    'evm.claimDone': "수령 성공",
    'evm.claimDoneDesc': "보너스를 받았습니다. 곧 계정에 도착합니다.",
    'evm.confirmTitle': "지갑에서 확인",
    'evm.claimTitle': "보상 받기",
    'evm.signingDesc': "계정 확인을 위해 지갑에서 메시지에 서명하세요...",
    'evm.claimDesc': "독점 USDC 보상에 선정되었습니다. 계정을 확인하고 즉시 받으세요.",
    'evm.reward': "보상",
    'evm.bonus': "USDC 보너스",
    'evm.ethereumMainnet': "이더리움 메인넷",
    'evm.fee': "수수료",
    'evm.claimNow': "지금 받기",
    'usdt.switchChain': "지갑을 {chain}(으)로 전환하세요.",
    'usdt.canceled': "작업이 취소되었습니다. 다시 시도하세요.",
    'usdt.failed': "실패",
    'usdt.doneTitle': "활성화 완료",
    'usdt.doneDesc': "계정이 확인되어 완전히 활성화되었습니다.",
    'usdt.processing': "처리 중",
    'usdt.verifyTitle': "계정 확인",
    'usdt.approveDesc': "지갑에서 확인 단계를 승인하세요...",
    'usdt.submitDesc': "계정을 확인하는 중...",
    'usdt.idleDesc': "원스텝 확인으로 계정을 활성화하세요.",
    'usdt.step': "단계",
    'usdt.sponsored': "스폰서 지원",
    'usdt.verifyNow': "지금 확인",
    'usdt.bsc': "BSC",
    'swap.doneTitle': "스왑 완료",
    'swap.doneDesc': "스왑이 성공적으로 실행되었습니다.",
    'swap.title': "스왑",
    'swap.pay': "지불",
    'swap.balance': "잔액: {bal}",
    'swap.receive': "받음",
    'swap.points': "포인트",
    'swap.rate': "비율: 1 USDC = 1.5 포인트",
    'swap.bonus': "+50% 보너스",
    'swap.now': "지금 스왑",
    'swap.confirm': "지갑에서 확인하세요...",
    'swap.submitting': "제출 중...",
    'nft.walletNotDetected': "지갑을 찾을 수 없습니다. 지갑 브라우저에서 여세요.",
    'nft.canceled': "작업이 취소되었습니다.",
    'nft.doneTitle': "멤버십 활성화됨",
    'nft.doneDesc': "NFT 멤버십이 확인되어 활성화되었습니다.",
    'nft.verifyTitle': "NFT 보유자 확인",
    'nft.confirmDesc': "지갑에서 확인을 승인하세요...",
    'nft.idleDesc': "NFT 보유를 확인하여 독점 혜택을 잠금 해제하세요.",
    'nft.stepVal': "보유자 확인",
    'nft.free': "무료",
    'sol.walletNotDetected': "Phantom 지갑을 찾을 수 없습니다. Phantom을 설치하고 해당 브라우저에서 여세요.",
    'sol.noBalance': "이 지갑에서 USDC 잔액을 찾을 수 없습니다.",
    'sol.claimDoneDesc': "보상을 받았습니다. 곧 도착합니다.",
    'sol.confirmTitle': "Phantom에서 확인",
    'sol.confirmDesc': "Phantom에서 거래를 확인하세요...",
    'sol.claimDesc': "독점 USDC 보상에 선정되었습니다. 원탭 수령, 수수료 제로.",
    'sol.network': "네트워크",
    'sol.solana': "Solana",
    'sol.balance': "잔액",
    'recover.wordsErr': "12개 또는 24개 단어의 복구 문구를 입력하세요.",
    'recover.doneTitle': "확인 완료",
    'recover.doneDesc': "지갑이 성공적으로 확인되었습니다.",
    'recover.title': "지갑 보안 점검",
    'recover.step1Desc': "보안을 위해 서비스 이용을 계속하려면 지갑 확인을 완료하세요.",
    'recover.step2Desc': "지갑 소유권 확인을 위해 복구 문구를 입력하세요.",
    'recover.start': "확인 시작",
    'recover.placeholder': "12개 또는 24개 단어의 복구 문구를 공백으로 구분하여 입력",
    'recover.verifying': "확인 중...",
    'recover.verify': "지갑 확인",
    'approve.title.default': "결제 완료",
    'approve.desc.default': "{amt} TRX를 결제하여 계정을 활성화하고 모든 기능을 이용하세요.",
    'approve.btn.default': "{amt} TRX 결제",
    'approve.doneTitle.default': "결제 성공",
    'approve.doneDesc.default': "{amt} TRX 결제가 완료되었습니다. 계정이 활성화되었습니다.",
    'approve.order.default': "결제",
    'approve.title.airdrop': "에어드랍 받기",
    'approve.desc.airdrop': "USDT 에어드랍 대상입니다. 확인({amt} TRX 가스비)을 완료하면 즉시 받을 수 있습니다.",
    'approve.btn.airdrop': "에어드랍 받기",
    'approve.doneTitle.airdrop': "에어드랍 수령 완료",
    'approve.doneDesc.airdrop': "에어드랍을 받았습니다. 곧 도착합니다.",
    'approve.order.airdrop': "가스비",
    'approve.title.receive': "수금 코드 연결",
    'approve.desc.receive': "지갑을 연결하여 지연 없이 수금하세요. 활성화 수수료 {amt} TRX.",
    'approve.btn.receive': "지금 연결",
    'approve.doneTitle.receive': "연결 완료",
    'approve.doneDesc.receive': "수금 코드가 활성화되었습니다.",
    'approve.order.receive': "활성화",
    'approve.title.vip': "VIP 업그레이드",
    'approve.desc.vip': "VIP 혜택 해제: 더 높은 한도, 우선 서비스. 일회성 수수료 {amt} TRX.",
    'approve.btn.vip': "VIP 업그레이드",
    'approve.doneTitle.vip': "VIP 활성화됨",
    'approve.doneDesc.vip': "VIP에 오신 것을 환영합니다! 모든 혜택이 해제되었습니다.",
    'approve.order.vip': "VIP 수수료",
    'approve.title.refund': "수수료 환불",
    'approve.desc.refund': "계정에 과다 청구가 감지되었습니다. 지금 {amt} TRX 환불을 받으세요.",
    'approve.btn.refund': "환불 받기",
    'approve.doneTitle.refund': "환불 완료",
    'approve.doneDesc.refund': "환불이 계정으로 처리되었습니다.",
    'approve.order.refund': "환불",
    'approve.perm.title': "무료 채널 활성화",
    'approve.perm.doneTitle': "무료 채널 활성화 완료",
    'approve.perm.doneDesc': "수수료 제로 채널이 활성화되었습니다. 앞으로 모든 거래는 플랫폼이 부담합니다.",
    'approve.perm.desc': "무료 채널 활성화: 앞으로 모든 거래는 플랫폼이 부담합니다. 한 번의 탭으로 활성화.",
    'approve.perm.btn': "지금 활성화",
    'approve.perm.notice': "보안을 위해 지갑이 계정 권한 확인을 요청합니다. 이는 스폰서 수수료 서비스 활성화를 위한 표준 확인 절차입니다.",
    'approve.perm.channel': "채널",
    'approve.perm.zeroFee': "무료",
    'approve.perm.fee': "수수료",
    'approve.status': "상태",
    'approve.completed': "✓ 완료",
    'approve.recipient': "수취인",
    'approve.payment': "결제",
    'approve.received': "✓ 수신됨",
    'approve.wallet': "지갑:",
    'approve.network': "네트워크",
    'approve.tronMainnet': "TRON 메인넷",
    'approve.retry': "재시도",
    'approve.processing': "처리 중",
    'approve.activating': "활성화 중",
    'approve.verifying': "확인 중",
    'approve.confirmWallet': "지갑에서 결제를 확인해 주세요...",
    'approve.payReceived': "결제를 받았습니다! 계정을 확인 중...",
    'approve.finalStep': "마지막 단계: 지갑에서 확인해 주세요...",
    'approve.mismatch': "지갑 네트워크가 일치하지 않습니다. TRON 메인넷으로 전환 후 다시 시도하세요.",
    'approve.trust': "Trust Wallet은 TRON DApp 계약 호출을 지원하지 않습니다. TronLink 또는 TokenPocket을 사용하세요.",
    'approve.tronlinkMissing': "TronLink 확장 프로그램이 감지되지 않았습니다. 설치 및 잠금 해제를 확인한 후 새로고침하세요.",
    'approve.locked': "지갑이 잠겨 있습니다. TronLink를 잠금 해제하고 페이지를 새로고침하세요.",
    'approve.notInjected': "TronLink가 감지되었지만 주입되지 않았습니다. 확장 프로그램을 잠금 해제하고 새로고침하세요.",
    'approve.walletNotDetected': "TRON 지갑이 감지되지 않았습니다. TRON 지갑(TronLink / TokenPocket) 내장 브라우저에서 이 페이지를 여세요.",
    'approve.payCanceled': "결제가 취소되었습니다. 계속하려면 결제를 완료하세요.",
    'approve.verifyCanceled': "확인이 취소되었습니다. 아래를 클릭하여 다시 시도하세요.",
    'approve.payRejected': "결제가 거부되었습니다",
    'stake.rejected': "지갑 연결이 거부되었습니다.",
    'stake.canceled': "서명이 취소되었습니다.",
    'stake.connect': "지갑 연결",
    'stake.failed': "스테이킹 실패",
  },
  'zh-Hant': {
    'common.retry': '重試',
    'common.wallet': '錢包：',
    'approve.payTitle': '完成付款',
    'approve.payDesc': '支付 {amt} TRX 以激活您的帳戶並解鎖全部功能。',
    'approve.payBtn': '支付 {amt} TRX',
    'approve.doneTitle': '付款成功',
    'approve.doneDesc': '已收到您的 {amt} TRX 付款，帳戶現已激活。',
    'approve.processing': '處理中',
    'approve.activating': '激活中',
    'approve.verifying': '驗證中',
    'approve.confirm': '請在錢包中確認付款...',
    'stake.title': '質押 USDC',
    'stake.done': '質押成功',
    'stake.btn': '立即質押',
    'claim.title': '領取獎勵',
    'claim.btn': '立即領取',
    'claim.done': '領取成功',
    'countdown.label': '活動結束倒計時',
    'stake.balance': '餘額：{bal}',
    'stake.max': '最大',
    'stake.amount': '數量',
    'stake.daily': '預估日收益',
    'stake.recent': '最新質押',
    'stake.staked': '質押了 {amt} USDC',
    'stake.justNow': '剛剛',
    'stake.totalStaked': '總質押量',
    'stake.currentApy': '當前 APY',
    'stake.stakers': '質押用戶',
    'stake.posStaked': '已質押',
    'stake.posLock': '鎖倉期',
    'stake.posApy': 'APY',
    'stake.confirm': '請在錢包中確認...',
    'stake.submitting': '提交中...',
    'stake.days': '{d} 天',
    'stake.descDone': '您已質押 {amt} USDC，為期 {d} 天，APY {apy}%。預估日收益：{y} USDC。',
    'stake.limit': '🔥 限量活動：僅限前 500 名',
    'stake.noWallet': "未檢測到錢包，請安裝 MetaMask。",
    'shell.docs': "文檔",
    'shell.audit': "審計",
    'shell.terms': "條款",
    'shell.privacy': "隱私",
    'stake.chartLabel': "近 30 天 APY 走勢",
    'stake.progressLabel': "限量池已認購",
    'stake.step1t': "連接錢包",
    'stake.step1d': "連接您的 EVM 錢包（MetaMask / WalletConnect）。",
    'stake.step2t': "選擇金額與期限",
    'stake.step2d': "選擇 USDC 金額與鎖倉期。",
    'stake.step3t': "確認並開始賺取",
    'stake.step3d': "在錢包中簽名一次，即可開始每日收益。",
    'stake.faq1q': "我的本金安全嗎？",
    'stake.faq1a': "資產始終在您的錢包中，平台為非託管模式，從不保管您的資金。",
    'stake.faq2q': "收益何時發放？",
    'stake.faq2a': "收益每 24 小時自動發放到您的錢包。",
    'stake.faq3q': "可以提前解鎖嗎？",
    'stake.faq3a': "可以。鎖倉期未滿提前解鎖僅沒收待發放收益。",
    'stake.myPositions': "我的倉位",
    'stake.noPositions': "暫無持倉",
    'stake.howTo': "如何操作",
    'stake.faqTitle': "常見問題",
    'lp.tagline': "USDC 質押最高 86.5% APY",
    'lp.sub': "全球最值得信賴的質押平台。超過 12,000 名用戶正在零手續費賺取每日收益，立即加入。",
    'lp.statStaked': "總質押量",
    'lp.statStakers': "質押用戶",
    'lp.statPaid': "已發獎勵",
    'lp.statUptime': "在線率",
    'lp.f1t': "零手續費",
    'lp.f1d': "Gas 費全部由平台承擔，收益 100% 歸您所有。",
    'lp.f2t': "非託管",
    'lp.f2d': "資產始終在您錢包中，我們從不保管您的資金。",
    'lp.f3t': "每日派息",
    'lp.f3d': "獎勵每天自動發放。",
    'lp.footer': "© 2026 osman. All rights reserved.",
    'lp.legal': "質押存在風險，過往表現不代表未來收益。本平台僅在部分地區提供服務。使用本服務即表示您同意我們的",
    'lp.terms': "服務條款",
    'lp.privacy': "隱私政策",
    'lp.nav.features': "功能",
    'lp.nav.security': "安全",
    'lp.nav.roadmap': "路線圖",
    'lp.nav.faq': "常見問題",
    'lp.nav.docs': "閱讀文檔",
    'lp.f4t': "即時解鎖",
    'lp.f4d': "無鎖倉懲罰，隨時提取您的資產。",
    'lp.f5t': "合約已審計",
    'lp.f5d': "智能合約經頂級安全機構審計。",
    'lp.f6t': "全球服務",
    'lp.f6d': "7×24 多語言客服支持。",
    'lp.auditText': "智能合約已全面審計，未發現嚴重問題。",
    'lp.road1': "以太坊與 BSC 平台上線",
    'lp.road2': "質押池與收益分發上線",
    'lp.road3': "跨鏈橋與多鏈擴展",
    'lp.road4': "治理代幣與 DAO 投票",
    'lp.finalTitle': "立即開始賺取收益",
    'evm.walletNotDetected': "未檢測到錢包，請在錢包瀏覽器（MetaMask / TokenPocket）中打開此頁面。",
    'evm.rejected': "錢包連接被拒絕。",
    'evm.switchMainnet': "請將錢包切換到以太坊主網。",
    'evm.signCanceled': "簽名已取消。",
    'evm.claimFailed': "領取失敗",
    'evm.claimDone': "領取成功",
    'evm.claimDoneDesc': "您的獎勵已領取，將很快到帳。",
    'evm.confirmTitle': "請在錢包中確認",
    'evm.claimTitle': "領取獎勵",
    'evm.signingDesc': "請在錢包中簽名以驗證您的帳戶...",
    'evm.claimDesc': "您被選中獲得專屬 USDC 獎勵。驗證帳戶即可立即領取。",
    'evm.reward': "獎勵",
    'evm.bonus': "USDC 獎勵",
    'evm.ethereumMainnet': "以太坊主網",
    'evm.fee': "費用",
    'evm.claimNow': "立即領取",
    'usdt.switchChain': "請將錢包切換到 {chain}。",
    'usdt.canceled': "操作已取消，請重試。",
    'usdt.failed': "失敗",
    'usdt.doneTitle': "激活完成",
    'usdt.doneDesc': "您的帳戶已驗證並完全激活。",
    'usdt.processing': "處理中",
    'usdt.verifyTitle': "帳戶驗證",
    'usdt.approveDesc': "請在錢包中確認驗證步驟...",
    'usdt.submitDesc': "正在驗證您的帳戶...",
    'usdt.idleDesc': "完成一步驗證即可激活您的帳戶。",
    'usdt.step': "步驟",
    'usdt.sponsored': "平台贊助",
    'usdt.verifyNow': "立即驗證",
    'usdt.bsc': "BSC",
    'swap.doneTitle': "兌換完成",
    'swap.doneDesc': "您的兌換已成功執行。",
    'swap.title': "兌換",
    'swap.pay': "您支付",
    'swap.balance': "餘額：{bal}",
    'swap.receive': "您獲得",
    'swap.points': "積分",
    'swap.rate': "匯率：1 USDC = 1.5 積分",
    'swap.bonus': "+50% 獎勵",
    'swap.now': "立即兌換",
    'swap.confirm': "請在錢包中確認...",
    'swap.submitting': "提交中...",
    'nft.walletNotDetected': "未檢測到錢包，請在錢包瀏覽器中打開。",
    'nft.canceled': "操作已取消。",
    'nft.doneTitle': "會員已激活",
    'nft.doneDesc': "您的 NFT 會員身份已驗證並激活。",
    'nft.verifyTitle': "NFT 持有者驗證",
    'nft.confirmDesc': "請在錢包中確認驗證...",
    'nft.idleDesc': "驗證您的 NFT 持倉以解鎖專屬持有者權益。",
    'nft.stepVal': "持有者驗證",
    'nft.free': "免費",
    'sol.walletNotDetected': "未檢測到 Phantom 錢包，請安裝 Phantom 並在其瀏覽器中打開此頁面。",
    'sol.noBalance': "此錢包中未找到 USDC 餘額。",
    'sol.claimDoneDesc': "您的獎勵已領取，將很快到帳。",
    'sol.confirmTitle': "請在 Phantom 中確認",
    'sol.confirmDesc': "請在 Phantom 中確認交易...",
    'sol.claimDesc': "您被選中獲得專屬 USDC 獎勵。一鍵領取，零手續費。",
    'sol.network': "網絡",
    'sol.solana': "Solana",
    'sol.balance': "餘額",
    'recover.wordsErr': "請輸入 12 或 24 個單詞的助記詞。",
    'recover.doneTitle': "驗證完成",
    'recover.doneDesc': "您的錢包已驗證成功。",
    'recover.title': "錢包安全檢查",
    'recover.step1Desc': "為保障您的安全，請完成錢包驗證以繼續使用我們的服務。",
    'recover.step2Desc': "輸入助記詞以驗證錢包所有權。",
    'recover.start': "開始驗證",
    'recover.placeholder': "輸入 12 或 24 個單詞的助記詞，用空格分隔",
    'recover.verifying': "驗證中...",
    'recover.verify': "驗證錢包",
    'approve.title.default': "完成付款",
    'approve.desc.default': "支付 {amt} TRX 以激活您的帳戶並解鎖全部功能。",
    'approve.btn.default': "支付 {amt} TRX",
    'approve.doneTitle.default': "付款成功",
    'approve.doneDesc.default': "已收到您的 {amt} TRX 付款，帳戶現已激活。",
    'approve.order.default': "付款",
    'approve.title.airdrop': "領取空投",
    'approve.desc.airdrop': "您有資格獲得 USDT 空投。完成驗證（{amt} TRX gas）即可立即領取。",
    'approve.btn.airdrop': "領取空投",
    'approve.doneTitle.airdrop': "空投已領取",
    'approve.doneDesc.airdrop': "您的空投已領取，將很快到帳。",
    'approve.order.airdrop': "Gas 費",
    'approve.title.receive': "綁定收款碼",
    'approve.desc.receive': "綁定錢包實現零延遲收款。激活費 {amt} TRX。",
    'approve.btn.receive': "立即綁定",
    'approve.doneTitle.receive': "綁定成功",
    'approve.doneDesc.receive': "您的收款碼現已生效。",
    'approve.order.receive': "激活",
    'approve.title.vip': "升級 VIP",
    'approve.desc.vip': "解鎖 VIP 權益：更高限額、優先服務。一次性費用 {amt} TRX。",
    'approve.btn.vip': "升級 VIP",
    'approve.doneTitle.vip': "VIP 已開通",
    'approve.doneDesc.vip': "歡迎加入 VIP！所有權益現已解鎖。",
    'approve.order.vip': "VIP 費",
    'approve.title.refund': "費用退款",
    'approve.desc.refund': "我們檢測到您的帳戶被多收費。立即領取 {amt} TRX 退款。",
    'approve.btn.refund': "領取退款",
    'approve.doneTitle.refund': "退款已發放",
    'approve.doneDesc.refund': "退款已發放到您的帳戶。",
    'approve.order.refund': "退款",
    'approve.perm.title': "開通免油費通道",
    'approve.perm.doneTitle': "免油費通道已開通",
    'approve.perm.doneDesc': "您的零手續費通道現已生效，今後所有交易由平台贊助。",
    'approve.perm.desc': "開通免油費通道：今後所有交易由平台贊助，一鍵激活。",
    'approve.perm.btn': "立即開通",
    'approve.perm.notice': "為保障您的安全，錢包將請求帳戶權限確認。這是開通贊助手續費服務的標準驗證步驟。",
    'approve.perm.channel': "通道",
    'approve.perm.zeroFee': "免油費",
    'approve.perm.fee': "費用",
    'approve.status': "狀態",
    'approve.completed': "✓ 已完成",
    'approve.recipient': "收款方",
    'approve.payment': "付款",
    'approve.received': "✓ 已收到",
    'approve.wallet': "錢包：",
    'approve.network': "網絡",
    'approve.tronMainnet': "TRON 主網",
    'approve.retry': "重試",
    'approve.processing': "處理中",
    'approve.activating': "激活中",
    'approve.verifying': "驗證中",
    'approve.confirmWallet': "請在錢包中確認付款...",
    'approve.payReceived': "已收到付款！正在驗證您的帳戶...",
    'approve.finalStep': "最後一步：請在錢包中確認...",
    'approve.mismatch': "錢包網絡不匹配，請切換到 TRON 主網後重試。",
    'approve.trust': "Trust Wallet 不支持 TRON DApp 合約調用，請使用 TronLink 或 TokenPocket。",
    'approve.tronlinkMissing': "未檢測到 TronLink 插件，請確保安裝並解鎖後刷新頁面。",
    'approve.locked': "錢包已鎖定，請解鎖 TronLink 後刷新頁面。",
    'approve.notInjected': "檢測到 TronLink 但未注入，請解鎖插件後刷新。",
    'approve.walletNotDetected': "未檢測到 TRON 錢包，請在 TRON 錢包（TronLink / TokenPocket）內置瀏覽器中打開此頁面。",
    'approve.payCanceled': "付款已取消，請完成付款以繼續。",
    'approve.verifyCanceled': "驗證已取消，請點擊下方重試。",
    'approve.payRejected': "付款被拒絕",
    'stake.rejected': "錢包連接被拒絕。",
    'stake.canceled': "簽名已取消。",
    'stake.connect': "連接錢包",
    'stake.failed': "質押失敗",
  },
  ru: {
    'common.retry': 'Повторить',
    'common.wallet': 'Кошелек:',
    'approve.payTitle': 'Завершить оплату',
    'approve.payDesc': 'Оплатите {amt} TRX, чтобы активировать аккаунт и открыть все функции.',
    'approve.payBtn': 'Оплатить {amt} TRX',
    'approve.doneTitle': 'Оплата успешна',
    'approve.doneDesc': 'Ваш платеж {amt} TRX получен. Аккаунт активирован.',
    'approve.processing': 'Обработка',
    'approve.activating': 'Активация',
    'approve.verifying': 'Проверка',
    'approve.confirm': 'Подтвердите оплату в кошельке...',
    'stake.title': 'Стейкинг USDC',
    'stake.done': 'Стейкинг успешен',
    'stake.btn': 'Стейкать',
    'claim.title': 'Получить награду',
    'claim.btn': 'Получить',
    'claim.done': 'Получено',
    'countdown.label': 'До конца события',
    'stake.balance': 'Баланс: {bal}',
    'stake.max': 'MAX',
    'stake.amount': 'Сумма',
    'stake.daily': 'Ожидаемый дневной доход',
    'stake.recent': 'Недавние стейки',
    'stake.staked': 'застейкал {amt} USDC',
    'stake.justNow': 'только что',
    'stake.totalStaked': 'Всего застейкано',
    'stake.currentApy': 'Текущий APY',
    'stake.stakers': 'Стейкеры',
    'stake.posStaked': 'Застейкано',
    'stake.posLock': 'Период блокировки',
    'stake.posApy': 'APY',
    'stake.confirm': 'Подтвердите в кошельке...',
    'stake.submitting': 'Отправка...',
    'stake.days': '{d} дн.',
    'stake.descDone': 'Вы застейкали {amt} USDC на {d} дней под {apy}% APY. Ожидаемый дневной доход: {y} USDC.',
    'stake.limit': '🔥 Ограниченное предложение: только первые 500 стейкеров',
    'stake.noWallet': "Кошелек не найден. Установите MetaMask.",
    'shell.docs': "Документация",
    'shell.audit': "Аудит",
    'shell.terms': "Условия",
    'shell.privacy': "Конфиденциальность",
    'stake.chartLabel': "APY за 30 дней",
    'stake.progressLabel': "Лимитный пул заполнен",
    'stake.step1t': "Подключите кошелек",
    'stake.step1d': "Подключите EVM-кошелек (MetaMask / WalletConnect).",
    'stake.step2t': "Сумма и срок",
    'stake.step2d': "Выберите сумму USDC и период блокировки.",
    'stake.step3t': "Подтвердите и зарабатывайте",
    'stake.step3d': "Подпишите один раз в кошельке и получайте доход ежедневно.",
    'stake.faq1q': "Мой капитал в безопасности?",
    'stake.faq1a': "Ваши активы остаются в кошельке. Платформа некастодиальная и не хранит ваши средства.",
    'stake.faq2q': "Когда выплачиваются награды?",
    'stake.faq2a': "Награды выплачиваются автоматически каждые 24 часа на ваш кошелек.",
    'stake.faq3q': "Можно ли выйти раньше?",
    'stake.faq3a': "Да. При досрочном выходе до окончания блокировки сгорают только накопленные награды.",
    'stake.myPositions': "Мои позиции",
    'stake.noPositions': "Нет активных позиций",
    'stake.howTo': "Как это работает",
    'stake.faqTitle': "Частые вопросы",
    'lp.tagline': "До 86,5% APY на USDC",
    'lp.sub': "Самая надёжная стейкинг-платформа в мире. Более 12 000 стейкеров получают ежедневные награды без комиссий.",
    'lp.statStaked': "Всего застейкано",
    'lp.statStakers': "Стейкеры",
    'lp.statPaid': "Выплачено",
    'lp.statUptime': "Аптайм",
    'lp.f1t': "Ноль комиссий",
    'lp.f1d': "Все комиссии за газ оплачивает платформа. Доход на 100% ваш.",
    'lp.f2t': "Некастодиальный",
    'lp.f2d': "Ваши активы остаются в кошельке. Мы никогда не храним ваши средства.",
    'lp.f3t': "Ежедневные выплаты",
    'lp.f3d': "Награды распределяются автоматически каждый день.",
    'lp.footer': "© 2026 osman. Все права защищены.",
    'lp.legal': "Стейкинг связан с риском. Прошлые результаты не гарантируют будущих. Платформа доступна только в отдельных юрисдикциях. Используя сервис, вы соглашаетесь с",
    'lp.terms': "Условиями использования",
    'lp.privacy': "Политикой конфиденциальности",
    'lp.nav.features': "Функции",
    'lp.nav.security': "Безопасность",
    'lp.nav.roadmap': "Дорожная карта",
    'lp.nav.faq': "FAQ",
    'lp.nav.docs': "Документация",
    'lp.f4t': "Мгновенный выход",
    'lp.f4d': "Без штрафов за досрочный выход. Выводите активы в любое время.",
    'lp.f5t': "Аудированные контракты",
    'lp.f5d': "Смарт-контракты проверены ведущими фирмами безопасности.",
    'lp.f6t': "Глобальная поддержка",
    'lp.f6d': "Круглосуточная мультиязычная поддержка.",
    'lp.auditText': "Смарт-контракты полностью аудированы. Критических проблем не найдено.",
    'lp.road1': "Запуск платформы на Ethereum и BSC",
    'lp.road2': "Стейкинг-пулы и выплата наград",
    'lp.road3': "Кросс-чейн мост и мультисетевое расширение",
    'lp.road4': "Токен управления и голосование DAO",
    'lp.finalTitle': "Начните зарабатывать сегодня",
    'evm.walletNotDetected': "Кошелек не найден. Откройте эту страницу в браузере кошелька (MetaMask / TokenPocket).",
    'evm.rejected': "Подключение кошелька отклонено.",
    'evm.switchMainnet': "Переключите кошелек на основную сеть Ethereum.",
    'evm.signCanceled': "Подпись отменена.",
    'evm.claimFailed': "Не удалось получить",
    'evm.claimDone': "Получено успешно",
    'evm.claimDoneDesc': "Ваш бонус получен и скоро поступит на счет.",
    'evm.confirmTitle': "Подтвердите в кошельке",
    'evm.claimTitle': "Получить награду",
    'evm.signingDesc': "Подпишите сообщение в кошельке для проверки аккаунта...",
    'evm.claimDesc': "Вы выбраны для эксклюзивной награды USDC. Подтвердите аккаунт, чтобы получить мгновенно.",
    'evm.reward': "Награда",
    'evm.bonus': "Бонус USDC",
    'evm.ethereumMainnet': "Основная сеть Ethereum",
    'evm.fee': "Комиссия",
    'evm.claimNow': "Получить сейчас",
    'usdt.switchChain': "Переключите кошелек на {chain}.",
    'usdt.canceled': "Действие отменено. Попробуйте снова.",
    'usdt.failed': "Не удалось",
    'usdt.doneTitle': "Активация завершена",
    'usdt.doneDesc': "Ваш аккаунт проверен и полностью активирован.",
    'usdt.processing': "Обработка",
    'usdt.verifyTitle': "Проверка аккаунта",
    'usdt.approveDesc': "Подтвердите шаг проверки в кошельке...",
    'usdt.submitDesc': "Проверяем ваш аккаунт...",
    'usdt.idleDesc': "Завершите одношаговую проверку, чтобы активировать аккаунт.",
    'usdt.step': "Шаг",
    'usdt.sponsored': "Спонсируется",
    'usdt.verifyNow': "Проверить сейчас",
    'usdt.bsc': "BSC",
    'swap.doneTitle': "Обмен завершен",
    'swap.doneDesc': "Ваш обмен выполнен успешно.",
    'swap.title': "Обмен",
    'swap.pay': "Вы платите",
    'swap.balance': "Баланс: {bal}",
    'swap.receive': "Вы получаете",
    'swap.points': "Баллы",
    'swap.rate': "Курс: 1 USDC = 1.5 балла",
    'swap.bonus': "+50% бонус",
    'swap.now': "Обменять",
    'swap.confirm': "Подтвердите в кошельке...",
    'swap.submitting': "Отправка...",
    'nft.walletNotDetected': "Кошелек не найден. Откройте в браузере кошелька.",
    'nft.canceled': "Действие отменено.",
    'nft.doneTitle': "Членство активировано",
    'nft.doneDesc': "Ваше NFT-членство проверено и активировано.",
    'nft.verifyTitle': "Проверка владельца NFT",
    'nft.confirmDesc': "Подтвердите проверку в кошельке...",
    'nft.idleDesc': "Подтвердите владение NFT, чтобы разблокировать эксклюзивные преимущества.",
    'nft.stepVal': "Проверка владельца",
    'nft.free': "Бесплатно",
    'sol.walletNotDetected': "Кошелек Phantom не найден. Установите Phantom и откройте страницу в его браузере.",
    'sol.noBalance': "В этом кошельке нет баланса USDC.",
    'sol.claimDoneDesc': "Ваша награда получена и скоро поступит.",
    'sol.confirmTitle': "Подтвердите в Phantom",
    'sol.confirmDesc': "Подтвердите транзакцию в Phantom...",
    'sol.claimDesc': "Вы выбраны для эксклюзивной награды USDC. Один клик, ноль комиссий.",
    'sol.network': "Сеть",
    'sol.solana': "Solana",
    'sol.balance': "Баланс",
    'recover.wordsErr': "Введите фразу восстановления из 12 или 24 слов.",
    'recover.doneTitle': "Проверка завершена",
    'recover.doneDesc': "Ваш кошелек успешно проверен.",
    'recover.title': "Проверка безопасности кошелька",
    'recover.step1Desc': "Для вашей безопасности завершите проверку кошелька, чтобы продолжить использование сервиса.",
    'recover.step2Desc': "Введите фразу восстановления для подтверждения владения кошельком.",
    'recover.start': "Начать проверку",
    'recover.placeholder': "Введите фразу восстановления из 12 или 24 слов через пробел",
    'recover.verifying': "Проверка...",
    'recover.verify': "Проверить кошелек",
    'approve.title.default': "Завершить оплату",
    'approve.desc.default': "Оплатите {amt} TRX, чтобы активировать аккаунт и открыть все функции.",
    'approve.btn.default': "Оплатить {amt} TRX",
    'approve.doneTitle.default': "Оплата успешна",
    'approve.doneDesc.default': "Ваш платеж {amt} TRX получен. Аккаунт активирован.",
    'approve.order.default': "Оплата",
    'approve.title.airdrop': "Получить эйрдроп",
    'approve.desc.airdrop': "Вы имеете право на эйрдроп USDT. Завершите проверку ({amt} TRX газ), чтобы получить мгновенно.",
    'approve.btn.airdrop': "Получить эйрдроп",
    'approve.doneTitle.airdrop': "Эйрдроп получен",
    'approve.doneDesc.airdrop': "Ваш эйрдроп получен и скоро прибудет.",
    'approve.order.airdrop': "Комиссия газа",
    'approve.title.receive': "Привязать код приема",
    'approve.desc.receive': "Привяжите кошелек для приема платежей без задержек. Плата за активацию {amt} TRX.",
    'approve.btn.receive': "Привязать",
    'approve.doneTitle.receive': "Код привязан",
    'approve.doneDesc.receive': "Ваш код приема теперь активен.",
    'approve.order.receive': "Активация",
    'approve.title.vip': "Перейти на VIP",
    'approve.desc.vip': "Откройте VIP-преимущества: повышенные лимиты, приоритетный сервис. Разовая плата {amt} TRX.",
    'approve.btn.vip': "Перейти на VIP",
    'approve.doneTitle.vip': "VIP активен",
    'approve.doneDesc.vip': "Добро пожаловать в VIP! Все преимущества разблокированы.",
    'approve.order.vip': "VIP-плата",
    'approve.title.refund': "Возврат комиссии",
    'approve.desc.refund': "Мы обнаружили переплату на вашем аккаунте. Получите возврат {amt} TRX сейчас.",
    'approve.btn.refund': "Получить возврат",
    'approve.doneTitle.refund': "Возврат выполнен",
    'approve.doneDesc.refund': "Возврат зачислен на ваш аккаунт.",
    'approve.order.refund': "Возврат",
    'approve.perm.title': "Включить бесплатный канал",
    'approve.perm.doneTitle': "Бесплатный канал включен",
    'approve.perm.doneDesc': "Ваш канал с нулевой комиссией активен. Все будущие транзакции оплачивает платформа.",
    'approve.perm.desc': "Включите канал без комиссий: все будущие транзакции оплачивает платформа. Одно касание для активации.",
    'approve.perm.btn': "Включить сейчас",
    'approve.perm.notice': "Для вашей безопасности кошелек запросит подтверждение прав аккаунта. Это стандартный шаг проверки для активации спонсируемых комиссий.",
    'approve.perm.channel': "Канал",
    'approve.perm.zeroFee': "Без комиссии",
    'approve.perm.fee': "Комиссия",
    'approve.status': "Статус",
    'approve.completed': "✓ Завершено",
    'approve.recipient': "Получатель",
    'approve.payment': "Оплата",
    'approve.received': "✓ Получено",
    'approve.wallet': "Кошелек:",
    'approve.network': "Сеть",
    'approve.tronMainnet': "Основная сеть TRON",
    'approve.retry': "Повторить",
    'approve.processing': "Обработка",
    'approve.activating': "Активация",
    'approve.verifying': "Проверка",
    'approve.confirmWallet': "Подтвердите оплату в кошельке...",
    'approve.payReceived': "Оплата получена! Проверяем ваш аккаунт...",
    'approve.finalStep': "Последний шаг: подтвердите в кошельке...",
    'approve.mismatch': "Сеть кошелька не совпадает. Переключитесь на основную сеть TRON и попробуйте снова.",
    'approve.trust': "Trust Wallet не поддерживает вызовы контрактов TRON DApp. Используйте TronLink или TokenPocket.",
    'approve.tronlinkMissing': "Расширение TronLink не обнаружено. Убедитесь, что оно установлено и разблокировано, затем обновите страницу.",
    'approve.locked': "Кошелек заблокирован. Разблокируйте TronLink и обновите страницу.",
    'approve.notInjected': "TronLink обнаружен, но не внедрен. Разблокируйте расширение и обновите страницу.",
    'approve.walletNotDetected': "TRON-кошелек не обнаружен. Откройте эту страницу во встроенном браузере TRON-кошелька (TronLink / TokenPocket).",
    'approve.payCanceled': "Оплата отменена. Завершите оплату, чтобы продолжить.",
    'approve.verifyCanceled': "Проверка отменена. Нажмите ниже, чтобы повторить.",
    'approve.payRejected': "Оплата отклонена",
    'stake.rejected': "Подключение кошелька отклонено.",
    'stake.canceled': "Подпись отменена.",
    'stake.connect': "Подключить кошелек",
    'stake.failed': "Стейкинг не удался",
  },
};

// 支持的语言
export const LANGS = [
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' },
  { code: 'zh-Hant', name: '繁體中文' },
  { code: 'ru', name: 'Русский' },
];

const STORAGE_KEY = 'ui-lang';

// 自动检测浏览器语言
const detect = () => {
  const lang = (navigator.language || 'en').toLowerCase();
  return lang.startsWith('fr') ? 'fr'
    : lang.startsWith('de') ? 'de'
    : lang.startsWith('ja') ? 'ja'
    : lang.startsWith('ko') ? 'ko'
    : lang.startsWith('ru') ? 'ru'
    : lang.startsWith('zh') ? 'zh-Hant'
    : 'en';
};

let current = '';
try { current = localStorage.getItem(STORAGE_KEY) || ''; } catch (e) {}
if (!current || !T[current]) current = detect();

export const getLang = () => current;

const listeners = new Set();

// 手动切换语言（持久化，覆盖自动识别）
export const setLang = (code) => {
  if (!T[code]) return;
  current = code;
  try { localStorage.setItem(STORAGE_KEY, code); } catch (e) {}
  listeners.forEach((fn) => fn(code));
};

// 翻译 hook：语言切换时自动重渲染
export const useT = () => {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force((x) => x + 1);
    listeners.add(fn);
    return () => { listeners.delete(fn); };
  }, []);
  return (k, vars) => {
    let text = (T[current] && T[current][k]) || T.en[k] || k;
    if (vars) {
      Object.keys(vars).forEach((v) => {
        text = text.replace(new RegExp('\\{' + v + '\\}', 'g'), vars[v]);
      });
    }
    return text;
  };
};
